var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNationMotion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.92,401.46a21.7,21.7,0,0,1,5.77-14.34C70.44,394.32,62.92,401.46,62.92,401.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3,397.4A21.73,21.73,0,0,1,86.76,397C80.85,401.45,71.3,397.4,71.3,397.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.25,392.74a17.13,17.13,0,0,1,2.11-12C76.89,386,72.25,392.74,72.25,392.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.84,375.91c12.25,3.27,18.82,13.92,18.82,13.92C48.19,389.84,39.84,375.91,39.84,375.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.41,380.94c-.64-13.21,12.27-28.16,12.27-28.16-2,16.4-12.27,28.16-12.27,28.16",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.35,343.32a35.44,35.44,0,0,1-4.65,18.92C52.88,353.74,59.35,343.32,59.35,343.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.37,370.15c-9.66-1-14.91-10.64-14.91-10.64C51.14,362.78,54.37,370.15,54.37,370.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.54,410.54a21.67,21.67,0,0,1,15.18-2.93C43.62,413,33.54,410.54,33.54,410.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.56,414.87a14.19,14.19,0,0,1-6.49,7.31C52.49,417.73,58.56,414.87,58.56,414.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.32,413.45a17.15,17.15,0,0,1-11.55,2.06C49.49,411.64,57.32,413.45,57.32,413.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.26,431.23a.8.8,0,0,1,0-.2c0-.15,0-.34,0-.57v-2.22c0-1,0-2.13,0-3.5s0-2.91-.09-4.63c-.09-3.43-.33-7.52-.68-12.05s-.94-9.48-1.7-14.67c-1.53-10.37-3.61-19.64-5.29-26.3-.84-3.33-1.55-6-2.07-7.87-.25-.9-.44-1.62-.58-2.14l-.14-.56c0-.12,0-.19,0-.19a1.52,1.52,0,0,1,.07.18l.18.55.66,2.11c.57,1.84,1.33,4.52,2.21,7.84a245.85,245.85,0,0,1,5.42,26.32c.76,5.19,1.29,10.17,1.67,14.7s.54,8.63.58,12.07c.06,1.72,0,3.28,0,4.64s0,2.55-.06,3.51-.06,1.67-.08,2.21c0,.23,0,.42,0,.58S62.27,431.23,62.26,431.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.53,403.27c.07-.1,4,2.46,8.72,5.71s8.54,6,8.48,6.08-4-2.46-8.72-5.72S44.47,403.37,44.53,403.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.73,404.68s.19-.26.59-.66l1.74-1.67,5.81-5.45,5.8-5.44,1.76-1.65a4.11,4.11,0,0,1,.68-.57,3.5,3.5,0,0,1-.56.69c-.38.43-1,1-1.66,1.75-1.43,1.46-3.45,3.42-5.73,5.54s-4.36,4-5.89,5.36l-1.83,1.57A4.25,4.25,0,0,1,61.73,404.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.14,397s10-.19,14.2,7.67A18,18,0,0,1,32.14,397Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.77,393s8.12,5.79,6.83,14.62A18,18,0,0,1,45.77,393Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.57,378.72s-3.21,11.18-13.4,13.18A21,21,0,0,1,88.57,378.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.33,337.19S54.07,345.5,52.66,359A27.38,27.38,0,0,1,41.33,337.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.71,411.07a5,5,0,0,1-.83.66c-.55.4-1.33,1-2.28,1.75a56.21,56.21,0,0,0-12.6,14c-.65,1-1.15,1.86-1.49,2.45a5,5,0,0,1-.57.9,4.38,4.38,0,0,1,.42-1c.29-.61.76-1.48,1.38-2.53a48.56,48.56,0,0,1,12.67-14.11c1-.73,1.8-1.29,2.38-1.65A4.49,4.49,0,0,1,83.71,411.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.63,419.36a21.75,21.75,0,0,1,2.92-15.18C76.92,413.65,72.63,419.36,72.63,419.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2,414.69A15.78,15.78,0,0,1,92.31,413C86.17,416.23,81.2,414.69,81.2,414.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.69 432.27 48.47 463.66 76.22 463.66 82.67 432.72 43.69 432.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.79,452.39c0,.09-7.12.16-15.89.16S47,452.48,47,452.39s7.11-.16,15.88-.16S78.79,452.3,78.79,452.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.89,450.85c0,.09-7.16.16-16,.16s-16-.07-16-.16,7.16-.17,16-.17S78.89,450.76,78.89,450.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.84,449.1c0,.09-7.16.17-16,.17s-16-.08-16-.17,7.16-.16,16-.16S78.84,449,78.84,449.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.66,461.87a24.61,24.61,0,0,1-.85-3.95,25.16,25.16,0,0,1-.53-4,25.28,25.28,0,0,1,.85,3.95A25.29,25.29,0,0,1,51.66,461.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.55,461.54a29.22,29.22,0,0,1-.35-3.86,31.63,31.63,0,0,1-.18-3.87,18.77,18.77,0,0,1,.51,3.85A20,20,0,0,1,53.55,461.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,461.54a18.76,18.76,0,0,1-.72-4,20.41,20.41,0,0,1-.22-4,32.22,32.22,0,0,1,.54,4A36.62,36.62,0,0,1,57,461.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4,461.7a20.29,20.29,0,0,1-.38-4,20,20,0,0,1,.12-4,34.69,34.69,0,0,1,.2,4A30.42,30.42,0,0,1,59.4,461.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.68,461.54a22.47,22.47,0,0,1-.29-3.81,23,23,0,0,1,0-3.83,22.66,22.66,0,0,1,.29,3.82A22.93,22.93,0,0,1,63.68,461.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8,461.71a47.24,47.24,0,0,1,.07-7.89,23.66,23.66,0,0,1,.13,3.94A24.07,24.07,0,0,1,66.8,461.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.73,461.29a26.59,26.59,0,0,1,.24-4.13,26.14,26.14,0,0,1,.56-4.09,53.3,53.3,0,0,1-.8,8.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.51,460.87A21.93,21.93,0,0,1,75,454a31.93,31.93,0,0,1-.72,3.46A30.73,30.73,0,0,1,73.51,460.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.51,426.05v5.88a2.3,2.3,0,0,0,2.31,2.31H83a2.3,2.3,0,0,0,2.31-2.31v-5.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.99 434.24 44.33 436.11 81.41 438.75 82.35 434.24 43.99 434.24",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563.75,
    y: 95.4,
    width: 31.41,
    height: 62.26,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.37,
    y: 95.4,
    width: 33.94,
    height: 62.26,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.37,
    y: 162.01,
    width: 33.94,
    height: 60.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "634.66 94.33 670.4 94.33 670.4 39.09 671.61 39.09 671.61 94.33 700.69 94.33 700.69 37.87 634.66 37.87 634.66 94.33",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.61,
    y: 95.4,
    width: 29.09,
    height: 62.26,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.61,
    y: 162.01,
    width: 29.09,
    height: 60.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563.75,
    y: 162.01,
    width: 31.41,
    height: 60.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.66,
    y: 162.01,
    width: 35.74,
    height: 60.16,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563.75,
    y: 223.25,
    width: 31.41,
    height: 54.21,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.61,
    y: 223.25,
    width: 29.09,
    height: 54.21,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "595.16 94.33 595.16 39.09 596.37 39.09 596.37 94.33 630.31 94.33 630.31 37.87 563.75 37.87 563.75 94.33 595.16 94.33",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.66,
    y: 223.25,
    width: 35.74,
    height: 54.21,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.37,
    y: 223.25,
    width: 33.94,
    height: 54.21,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.66,
    y: 95.4,
    width: 35.74,
    height: 62.26,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.99,
    y: 52.57,
    width: 77.49,
    height: 128.27,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.42,
    y: 52.57,
    width: 77.49,
    height: 128.27,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.72,
    y: 55.17,
    width: 70.89,
    height: 123.06,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 472.21,
    y: 71.16,
    width: 43.59,
    height: 91.08,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.21,130c-.1-8.5,7.55-16.81,16-18,4-.56,8.28.23,12-1.31,6.7-2.74,8.83-11.65,15.57-14.29l.31,65.83h-43.9Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M710.14,462.25c0,.14-150.06.26-335.12.26s-335.16-.12-335.16-.26S189.89,462,375,462,710.14,462.11,710.14,462.25Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stage--inject-142"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.44,
    y: 390.21,
    width: 355.64,
    height: 72.04,
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.75,
    y: 386.14,
    width: 405.01,
    height: 8.28,
    style: {
      fill: "#ae7461"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M647.8,394.39c0,.14-90.3.26-201.66.26s-201.68-.12-201.68-.26,90.28-.26,201.68-.26S647.8,394.25,647.8,394.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M623.38,439c0,.14-79.49.26-177.51.26s-177.52-.12-177.52-.26,79.46-.26,177.52-.26S623.38,438.83,623.38,439Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M622.69,415.45c0,.15-79.48.27-177.5.27s-177.52-.12-177.52-.27,79.46-.26,177.52-.26S622.69,415.31,622.69,415.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.36,363.07s-3.47-23.88-3.18-37.78,0-29.53,0-29.53h1.6s-1.08,27.58.1,44.22,4.28,23.09,4.28,23.09h-2.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.71,268.88a4.23,4.23,0,0,0-1.46-2.13,4,4,0,0,0-3.48,0c-4.84,1.71-9.12,10.73-11.08,15.47l6.42,21.64C342.7,293.13,344.71,279,340.71,268.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.88,267.62a1.27,1.27,0,0,1-.1.28c-.08.21-.18.47-.31.79-.28.68-.68,1.67-1.15,2.9-.95,2.46-2.15,5.9-3.23,9.77s-1.81,7.43-2.26,10c-.23,1.29-.41,2.35-.52,3.07-.05.34-.1.62-.13.84a1.48,1.48,0,0,1-.07.29,1.69,1.69,0,0,1,0-.3q0-.33.09-.84c.08-.73.23-1.79.43-3.09a92,92,0,0,1,5.51-19.84c.49-1.22.91-2.2,1.22-2.87.15-.31.27-.57.36-.77A1.5,1.5,0,0,1,338.88,267.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.26,309.07a19.58,19.58,0,0,1-9.9-16.45c-.23-4.8,1.24-9.52,2.92-14a1.77,1.77,0,0,1,.68-1,1.71,1.71,0,0,1,1.64.26c4.37,2.49,7,7.23,8.43,12.07a24.19,24.19,0,0,1,1,9.92,16.46,16.46,0,0,1-4.76,9.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.26,309.07a1.11,1.11,0,0,1,0-.29c0-.22,0-.49,0-.83,0-.72,0-1.76-.09-3.05a83.42,83.42,0,0,0-1.12-10c-.67-3.87-1.48-7.34-2.07-9.85l-.72-3q-.11-.49-.18-.81A1.28,1.28,0,0,1,324,281a1.33,1.33,0,0,1,.1.28c.06.21.14.47.23.79.2.7.47,1.7.8,2.95.64,2.5,1.48,6,2.15,9.86a73,73,0,0,1,1.05,10c0,1.29,0,2.34,0,3.06,0,.34,0,.61,0,.83A1.11,1.11,0,0,1,328.26,309.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M328.26,309.07a19.58,19.58,0,0,1-9.9-16.45c-.23-4.8,1.24-9.52,2.92-14a1.77,1.77,0,0,1,.68-1,1.71,1.71,0,0,1,1.64.26c4.37,2.49,7,7.23,8.43,12.07a24.19,24.19,0,0,1,1,9.92,16.46,16.46,0,0,1-4.76,9.24"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M335.05,345.62c5.92,1.3,10.8,5.48,16.52,7.51,3.78,1.35,8.06,1.82,11.07,4.47-.72-1.83-2.44-3.05-4.11-4.09a73.49,73.49,0,0,0-15-7.15c-2.69-.93-5.6-1.71-8.34-.94",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.48,350.9c-7.42-.12-15.23-6.44-22.61-6.82,7.73-2.49,18.79-.45,22.61,6.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.38,333.1a24.19,24.19,0,0,1,11.86-.81,72.91,72.91,0,0,1,11.58,3.15c-.38-2.58-2.46-4.51-4.42-6.22a30.94,30.94,0,0,0-4.65-3.58,10.36,10.36,0,0,0-5.58-1.57,8.83,8.83,0,0,0-6.15,3.1,10.25,10.25,0,0,0-2.64,5.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.16,324.91c-4.68-4-11.75-3.6-17.89-3.46A145.8,145.8,0,0,1,324,338.73C324.26,334.39,320.05,329.94,314.16,324.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M314.16,324.91c-4.68-4-11.75-3.6-17.89-3.46A145.8,145.8,0,0,1,324,338.73C324.26,334.39,320.05,329.94,314.16,324.91Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M331.48,319.4a51.89,51.89,0,0,1,7.19-4.17c2.45-1.12,4.75-2.9,7.12-4.18,3.08-1.67,5.75-4,8.57-6.06s5.93-3.93,9.39-4.47a18.32,18.32,0,0,0-8.54.49,55.29,55.29,0,0,0-8,3.13c-3.65,1.64-7.35,3.32-10.33,6s-5.67,5.29-5.36,9.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.43,350.9a1.15,1.15,0,0,1-.23-.1l-.65-.34c-.56-.3-1.36-.74-2.37-1.25-.5-.26-1.06-.53-1.66-.82s-1.24-.58-1.92-.88a27.17,27.17,0,0,0-4.57-1.59,9.77,9.77,0,0,0-4.76-.12,13.36,13.36,0,0,0-2,.6,10.78,10.78,0,0,0-1.63.84,10,10,0,0,0-2,1.69c-.43.46-.64.74-.66.72a.93.93,0,0,1,.13-.21c.1-.14.25-.34.45-.58a9.45,9.45,0,0,1,2-1.78,9.82,9.82,0,0,1,1.65-.88,13.17,13.17,0,0,1,2-.64,9.88,9.88,0,0,1,4.88.1,26.9,26.9,0,0,1,4.6,1.63c.69.3,1.34.6,1.93.91s1.15.57,1.65.85c1,.53,1.79,1,2.33,1.32l.62.38C351.36,350.84,351.44,350.89,351.43,350.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,347.22a1.4,1.4,0,0,1,.46.14,9.65,9.65,0,0,1,1.21.52,14.69,14.69,0,0,1,6.2,6,12.19,12.19,0,0,1,.58,1.18,1.77,1.77,0,0,1,.15.46s-.32-.61-.89-1.55a16.6,16.6,0,0,0-6.12-5.88C321.57,347.52,320.93,347.26,321,347.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.53,324.53l.32.1.89.31,1.4.52c.55.21,1.15.51,1.82.8a43.39,43.39,0,0,1,9.66,6.16,47.38,47.38,0,0,1,4.5,4.43,49.72,49.72,0,0,1,3.2,4c.85,1.2,1.49,2.2,1.93,2.89l.51.8a1.25,1.25,0,0,1,.16.29,2.17,2.17,0,0,1-.21-.26c-.13-.17-.32-.43-.55-.77-.46-.67-1.13-1.66-2-2.84s-1.95-2.55-3.23-4a49.52,49.52,0,0,0-4.49-4.39,45.53,45.53,0,0,0-9.57-6.19c-.67-.3-1.25-.62-1.79-.83L305.7,325l-.87-.36A1.62,1.62,0,0,1,304.53,324.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.52,328.93a2.37,2.37,0,0,1-.6-.08l-.68-.12c-.26-.05-.57-.06-.91-.09a9.25,9.25,0,0,0-5.1,1,9,9,0,0,0-2.32,1.72,10.46,10.46,0,0,0-1.49,1.84,16.33,16.33,0,0,0-1,2,2.46,2.46,0,0,1,.15-.58,8.9,8.9,0,0,1,.71-1.47,9.42,9.42,0,0,1,1.48-1.91,8.79,8.79,0,0,1,2.37-1.79,9.15,9.15,0,0,1,5.24-1c.34.05.65.06.92.13l.68.17A2.64,2.64,0,0,1,340.52,328.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,305.8l-.28.17-.83.45c-.72.39-1.75,1-3,1.7s-2.73,1.67-4.3,2.8a35.65,35.65,0,0,0-4.8,4,12.26,12.26,0,0,0-2,2.54q-.74,1.39-1.38,2.7a49.58,49.58,0,0,0-2.06,4.69,27.66,27.66,0,0,0-1,3.31c-.19.79-.26,1.24-.29,1.23a1.29,1.29,0,0,1,0-.32c0-.22.07-.53.16-.94a23.93,23.93,0,0,1,.92-3.34,45.45,45.45,0,0,1,2-4.74c.43-.87.89-1.78,1.37-2.71a12.42,12.42,0,0,1,2-2.61,34.61,34.61,0,0,1,4.85-4c1.59-1.12,3.08-2,4.35-2.76s2.32-1.27,3.06-1.63l.85-.41A1.18,1.18,0,0,1,348,305.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.17,328.26a3,3,0,0,1-.15-.63c-.09-.45-.19-1-.32-1.71a50.47,50.47,0,0,0-1.41-5.57,47.9,47.9,0,0,0-2.12-5.33c-.28-.64-.53-1.17-.72-1.59a3.63,3.63,0,0,1-.24-.6,2.4,2.4,0,0,1,.33.55c.2.36.48.89.8,1.56a36.71,36.71,0,0,1,3.54,10.95c.12.73.2,1.32.24,1.73A2.79,2.79,0,0,1,327.17,328.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.63,311.38a20.24,20.24,0,0,0-2.41-8A26.45,26.45,0,0,0,306.3,290l16.59,24.74,2.14,4.41A12.68,12.68,0,0,0,326.63,311.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.85,
    y: 360.12,
    width: 38.58,
    height: 6.84,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.73 365.6 318.02 386.82 343.63 386.82 347.55 365.6 314.73 365.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.41,367c0,.08-8.7.14-19.44.14s-19.43-.06-19.43-.14,8.7-.13,19.43-.13S350.41,366.89,350.41,367Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-142"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.58,
    y: 48.52,
    width: 244.53,
    height: 202.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.11,250.93c0-1.41-.06-80.43-.17-202.41l.17.17-244.5,0h0l.21-.2c0,73.27,0,142.42,0,202.41l-.18-.18,244.53.18-244.53.18h-.17v-.18c0-60,0-129.14,0-202.41v-.2h.23l244.5,0h.17v.17C328.18,170.5,328.11,249.52,328.11,250.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.21,
    y: 171.33,
    width: 83.49,
    height: 5.53,
    rx: 2.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.21,
    y: 182.76,
    width: 83.49,
    height: 5.53,
    rx: 2.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.21,
    y: 193.34,
    width: 46.18,
    height: 5.53,
    rx: 2.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.1,
    y: 44.82,
    width: 259.58,
    height: 14.92,
    rx: 6.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,173.69c0,.06-22.68.1-50.65.1s-50.65,0-50.65-.1,22.67-.1,50.65-.1S210.37,173.63,210.37,173.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,184.88c0,.05-22.68.1-50.65.1s-50.65,0-50.65-.1,22.67-.11,50.65-.11S210.37,184.82,210.37,184.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,196.06c0,.06-22.68.11-50.65.11s-50.65,0-50.65-.11,22.67-.1,50.65-.1S210.37,196,210.37,196.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,207.25c0,.06-22.68.1-50.65.1s-50.65,0-50.65-.1,22.67-.11,50.65-.11S210.37,207.19,210.37,207.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,218.43c0,.06-22.68.11-50.65.11s-50.65,0-50.65-.11,22.67-.1,50.65-.1S210.37,218.38,210.37,218.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.27,
    y: 197.02,
    width: 10.09,
    height: 32.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.33,
    y: 186.28,
    width: 10.09,
    height: 43.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.15,
    y: 214.3,
    width: 10.09,
    height: 15.21,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.84,
    y: 209.77,
    width: 10.09,
    height: 19.75,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.15,
    y: 204.02,
    width: 10.09,
    height: 25.49,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.29,229.53h-7.06l-19.27,0-63.56,0H108.74v-.09c0-18.83,0-35.46,0-47.4,0-6,0-10.74,0-14,0-1.65,0-2.92,0-3.79,0-.43,0-.76,0-1s0-.34,0-.34,0,.12,0,.34,0,.55,0,1c0,.87,0,2.14,0,3.79,0,3.3,0,8.08,0,14,0,11.94,0,28.57,0,47.4l-.1-.09H121.4l63.56,0,19.27,0,5.24,0h1.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85,179.34a15.07,15.07,0,0,1-2.5.1,15.15,15.15,0,0,1-2.51-.1,15.15,15.15,0,0,1,2.51-.1A15.07,15.07,0,0,1,113.85,179.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85,190a14.4,14.4,0,0,1-2.5.11,14.47,14.47,0,0,1-2.51-.11,15.15,15.15,0,0,1,2.51-.1A15.07,15.07,0,0,1,113.85,190Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85,200.62a14.4,14.4,0,0,1-2.5.11,14.47,14.47,0,0,1-2.51-.11,16.58,16.58,0,0,1,2.51-.1A16.5,16.5,0,0,1,113.85,200.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.85,211.26a14.4,14.4,0,0,1-2.5.11,14.47,14.47,0,0,1-2.51-.11,16.58,16.58,0,0,1,2.51-.1A16.5,16.5,0,0,1,113.85,211.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.34,
    y: 81.67,
    width: 82.42,
    height: 8.22,
    rx: 3.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.74,
    y: 105.27,
    width: 189.75,
    height: 5.53,
    rx: 2.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.74,
    y: 118.46,
    width: 189.75,
    height: 5.53,
    rx: 2.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.74,
    y: 131.65,
    width: 189.75,
    height: 5.53,
    rx: 2.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.03,
    y: 144.84,
    width: 46.18,
    height: 5.53,
    rx: 2.45,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M656.82,224l-2-7.12A23.52,23.52,0,1,1,663,219h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.82,224l.4-.35,1.17-1,4.52-3.73,0,.16h0a.09.09,0,0,1-.06-.12.08.08,0,0,1,.09-.06,23.64,23.64,0,0,0,11.34-2,22.82,22.82,0,0,0,6.21-4.14,23.29,23.29,0,0,0,5.06-6.72,23.28,23.28,0,0,0-14.67-32.87,22.92,22.92,0,0,0-11.18-.29,23.7,23.7,0,0,0-9.63,4.62,23.27,23.27,0,0,0-6.27,7.89,23.38,23.38,0,0,0,11,31.41.15.15,0,0,1,0,.06l1.43,5.28c.16.59.29,1,.37,1.38s.13.48.13.48-.05-.14-.14-.44-.23-.76-.4-1.34c-.36-1.22-.89-3-1.57-5.31l0,.06a23.51,23.51,0,0,1-13.64-22.57,23.81,23.81,0,0,1,2.35-9.19,23.56,23.56,0,0,1,6.36-8,23.91,23.91,0,0,1,9.8-4.71,23.37,23.37,0,0,1,11.38.28,23.66,23.66,0,0,1,14.88,33.45A23.51,23.51,0,0,1,663,219.06l0-.18h0a.09.09,0,0,1,.06.12l0,.05-4.64,3.68-1.18.92C657,223.86,656.82,224,656.82,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.19,190.44h3.51a3,3,0,0,1,3-3,2.84,2.84,0,0,1,2.75,1.81,3.12,3.12,0,0,1-.25,2.83c-.6,1-1.9,1.88-4.26,1.46v7.9h3.46v-4.63a6.76,6.76,0,0,0,4.86-6.61c0-5.12-4.59-6.31-6.56-6.31C663.25,183.9,658.13,184.26,658.19,190.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 662.98,
    y: 203.08,
    width: 3.52,
    height: 3.28,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.85,107.26l3.26-5.67a20.84,20.84,0,1,1,3.68,6.49h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.85,107.26l.46,0,1.35.14,5.15.57-.09.12h0a.08.08,0,0,1,0-.11.08.08,0,0,1,.1,0,20.73,20.73,0,0,0,8.27,5.94,20.84,20.84,0,0,0,13.84.45,20.6,20.6,0,0,0,11.81-29.57,20.42,20.42,0,0,0-6.71-7.27,21,21,0,0,0-8.88-3.27,20.69,20.69,0,0,0-22,27.25.08.08,0,0,1,0,.07l-2.46,4.17c-.27.47-.49.83-.64,1.08l-.23.38a3.46,3.46,0,0,1,.19-.36l.6-1.08,2.4-4.27v.07a20.72,20.72,0,0,1-.93-10.22,20.94,20.94,0,0,1,6.83-12.35,21.16,21.16,0,0,1,7.28-4.18,20.83,20.83,0,0,1,9-.92,21.25,21.25,0,0,1,9,3.31,20.92,20.92,0,0,1-12.7,38.39,20.49,20.49,0,0,1-6.53-1.44,20.77,20.77,0,0,1-8.31-6.07l.14-.09h0a.08.08,0,0,1,0,.11h0l-5.2-.68-1.31-.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.22,94.81a2,2,0,1,1-2-2A2,2,0,0,1,452.22,94.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.13,94.75a2,2,0,1,1-2-2A2,2,0,0,1,460.13,94.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468,93.7a2,2,0,1,1-2.7-.7A2,2,0,0,1,468,93.7Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-142"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "624.74 447.17 624.74 429.89 639.03 428.99 638.14 447.6 631.35 450.25 624.74 447.17",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.43,447.48l-5.69-.31s-8.76,7.09-9.6,11a8.73,8.73,0,0,0,0,3l13.3.39h9.7V447.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.7,387c0,.8,6.85,50.51,6.85,50.51l17.25,0L639.36,386Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 614.99,
    y: 459.63,
    width: 23.12,
    height: 2.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.86,448.25c.15,0-.47,2.41-.94,5.39s-.67,5.42-.82,5.41a17.76,17.76,0,0,1,.3-5.5A18.15,18.15,0,0,1,625.86,448.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.16,458.35a12.77,12.77,0,0,0-1.21-2.19,6.39,6.39,0,0,0-2-1.71,6.14,6.14,0,0,0-6.18.29,6.38,6.38,0,0,0-1.86,1.89,11.53,11.53,0,0,0-1,2.3,1.43,1.43,0,0,1,0-.7,5.73,5.73,0,0,1,.64-1.79,6.5,6.5,0,0,1,1.91-2.1,6.43,6.43,0,0,1,3.3-1.1,6.27,6.27,0,0,1,5.48,2.7,5.79,5.79,0,0,1,.81,1.72A1.64,1.64,0,0,1,637.16,458.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "662.26 448.38 663.28 431.13 649.06 429.38 648.86 448.01 655.48 451.06 662.26 448.38",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.56,448.35l5.7,0s8.32,7.59,8.94,11.52a8.59,8.59,0,0,1-.18,3l-13.3-.4-9.68-.56.82-13.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.89,391c0,.81-7.61,50.4-7.61,50.4L646,441.13l1.23-51.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.09,
    y: 460.71,
    width: 23.12,
    height: 2.41,
    transform: "translate(1290.95 961.89) rotate(-176.62)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.08,449.39a18.26,18.26,0,0,1,1.14,5.38,17.94,17.94,0,0,1,0,5.51c-.15,0-.18-2.46-.5-5.45S660.93,449.42,661.08,449.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.21,458.81s0-.26.13-.69a5.86,5.86,0,0,1,.91-1.66,6.23,6.23,0,0,1,5.63-2.37,6.2,6.2,0,0,1,3.23,1.29,6.45,6.45,0,0,1,1.78,2.21,5.7,5.7,0,0,1,.54,1.82,1.5,1.5,0,0,1,0,.7,12.51,12.51,0,0,0-.86-2.35,6.37,6.37,0,0,0-1.74-2,6.13,6.13,0,0,0-6.16-.65,6.29,6.29,0,0,0-2.12,1.58A11.78,11.78,0,0,0,649.21,458.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.13,249.69s3.16-3.05,4.13-6,2.88-7.23,3.07-8.15-.77-1.34-1.9-.46-1.65,2.56-2.21,4.06-1.42,1.33-1.42,1.33,1.51-7,1.86-9.28c.38-2.4.88-4.27-.21-4.65s-1.58.71-2,2.43-1.53,5.7-1.53,5.7l.75-6.42s.72-3.45-.77-3.47-1.51,3.51-1.51,3.51l-1.23,6.45s1-8.12.44-8.42-1.51-.49-1.89,2.05-1.53,7.75-1.53,7.75l-.22,0,.51-5.48a2.07,2.07,0,0,0-.05-1.05c-.29-.5-.95-.83-1.37.78-.49,1.84-1.43,8.14-1.69,10.39a68.41,68.41,0,0,0,.12,7.94L595,253.91l8.72,4.76Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.23,
    y: 275.92,
    width: 19.43,
    height: 16.86,
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619,289.05l-8.55-1.22L597,281.34l10-25.48-12.49-6.19s-10.61,23.31-12.46,30-2.3,10,2,13.53,35.78,18.61,35.78,18.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.91,288.45l-6.5-1.89-18.28-.73s-2.52-.23-8.73,1.21c-4.67,1.08-10.82,2.14-10.82,2.14s-1.32,15.43-1.32,18.58l5.48,26.37h45l2.74-19c0,.06,2.72-21.06,2.7-21.11S664.93,289.87,659.91,288.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.18,281.44a13.25,13.25,0,0,0-3.74,1.88,13.75,13.75,0,0,0-2.74,3.17,3.41,3.41,0,0,1,.5-1.16,8.47,8.47,0,0,1,4.73-3.69A3.06,3.06,0,0,1,597.18,281.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.15,294a16.77,16.77,0,0,1,6,11c1,7.5,3.17,29.11,3.17,29.11H667.34l-2.28-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.53,302.72a1.11,1.11,0,0,1,0,.32c0,.25,0,.55-.09.91-.08.79-.22,1.93-.41,3.34-.39,2.82-1,6.7-1.7,11l-1.8,11c-.22,1.36-.4,2.48-.53,3.32l-.15.91a1.28,1.28,0,0,1-.08.31,1.11,1.11,0,0,1,0-.32c0-.25.05-.55.09-.91.08-.8.22-1.94.42-3.35.38-2.81,1-6.69,1.69-11l1.8-10.95c.22-1.37.4-2.49.53-3.33l.15-.9A1.28,1.28,0,0,1,669.53,302.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.24,294.68a32.2,32.2,0,0,1,.73,3.61c.41,2.23,1,5.3,1.71,8.7s1.25,6.49,1.57,8.75c.16,1.12.28,2,.33,2.67a3.92,3.92,0,0,1,0,1,29.11,29.11,0,0,1-.73-3.6c-.41-2.23-1-5.31-1.72-8.71s-1.25-6.49-1.57-8.74c-.16-1.13-.27-2-.33-2.68A3.59,3.59,0,0,1,612.24,294.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.2,388.71a13.34,13.34,0,0,1-13.37-12.92c-.37-13.53-.38-34.48-.36-43.56a4.46,4.46,0,0,1,4.46-4.46h69.51a4.46,4.46,0,0,1,4.46,4.57c-.22,9.43-.76,31.31-1.09,44.86A11.79,11.79,0,0,1,669,388.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.39,462.79l-4-.48,8.19-66.95a7.76,7.76,0,0,1,7.65-6.89h58.61a7.78,7.78,0,0,1,7.65,6.87c2,15.82,7.42,66.49,7.47,67l-4,.43c0-.51-5.51-51.15-7.46-66.94a3.77,3.77,0,0,0-3.68-3.36H613.26a3.76,3.76,0,0,0-3.68,3.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.39,462.79s0-.36.11-1.05.2-1.73.36-3.06c.32-2.7.79-6.65,1.39-11.75,1.22-10.19,3-24.94,5.18-43.21q.42-3.42.85-7a7.54,7.54,0,0,1,.34-1.83,4,4,0,0,1,1-1.59,3.86,3.86,0,0,1,1.71-.92,8.9,8.9,0,0,1,1.91-.11H630l34.72,0h6.95a4,4,0,0,1,2.36.67,4.1,4.1,0,0,1,1.52,1.94,10.86,10.86,0,0,1,.4,2.39c.18,1.58.35,3.17.53,4.76q1.08,9.57,2.19,19.54c1.48,13.29,3,27.07,4.6,41.21l-.28-.23,4-.43-.23.29c-.2-1.83-.42-3.8-.64-5.78-1.45-13-2.87-25.74-4.25-38.1q-1-9.27-2-18.25c-.16-1.49-.33-3-.5-4.46a7.82,7.82,0,0,0-1.47-4,7.54,7.54,0,0,0-3.35-2.56,7.63,7.63,0,0,0-2-.47c-.7-.05-1.45,0-2.16,0l-33.24,0-15.37,0h-7.33c-.6,0-1.21,0-1.78,0a7.5,7.5,0,0,0-1.69.37,7.25,7.25,0,0,0-2.87,1.8,7.54,7.54,0,0,0-1.79,2.81,14.4,14.4,0,0,0-.61,3.28q-.4,3.33-.8,6.53-.79,6.39-1.51,12.23c-1,7.78-1.84,14.79-2.6,20.94-1.54,12.27-2.64,21.07-3.22,25.65l0-.06,3,.39,1,.14-.95-.09-3-.34h0v-.05c.54-4.58,1.59-13.39,3-25.66.74-6.15,1.58-13.16,2.52-20.95q.7-5.83,1.48-12.24.39-3.19.79-6.53a14.9,14.9,0,0,1,.62-3.36,8,8,0,0,1,1.87-3,7.91,7.91,0,0,1,3-1.9,8.32,8.32,0,0,1,1.78-.39c.62,0,1.22,0,1.82,0H637l33.24,0c.73,0,1.43,0,2.19,0a8.27,8.27,0,0,1,2.2.5,8,8,0,0,1,3.56,2.73,8.15,8.15,0,0,1,1.58,4.24c.17,1.48.33,3,.5,4.46q1,9,2,18.25c1.38,12.36,2.8,25.1,4.25,38.1.23,2,.45,4,.65,5.78l0,.26-.26,0-4,.42-.26,0,0-.26c-1.58-14.14-3.11-27.91-4.59-41.2q-1.11-10-2.18-19.54c-.17-1.59-.35-3.18-.52-4.76a11.55,11.55,0,0,0-.37-2.28,3.59,3.59,0,0,0-1.34-1.71,3.41,3.41,0,0,0-2.09-.59h-6.95l-34.72,0H614.29a7.75,7.75,0,0,0-1.82.09,3.49,3.49,0,0,0-1.54.82,3.8,3.8,0,0,0-1,1.44,7.54,7.54,0,0,0-.31,1.74q-.45,3.6-.87,7l-5.39,43.26c-.64,5.07-1.14,9-1.47,11.69l-.39,3C601.45,462.46,601.39,462.79,601.39,462.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.84,376.59a1,1,0,0,1,0,.29,2.38,2.38,0,0,1,0,.89,4.32,4.32,0,0,1-2,2.72c-2.45,1.75-6.7,2.83-11.91,3.5-10.46,1.29-25.06,1.12-41-.38a14.57,14.57,0,0,1-5.79-1.57,7.77,7.77,0,0,1-3.49-4.65,26.32,26.32,0,0,1-.93-5.53c-.17-1.81-.33-3.58-.49-5.31-.6-6.93-.94-13.18-1.14-18.44s-.23-9.51-.24-12.45c0-1.47,0-2.61,0-3.38,0-.36,0-.65,0-.88a1,1,0,0,1,0-.3,1.16,1.16,0,0,1,0,.3l0,.88c0,.81,0,1.94.07,3.38.06,2.94.16,7.19.4,12.44s.63,11.49,1.24,18.4q.25,2.6.51,5.31a27.29,27.29,0,0,0,.92,5.43,7.28,7.28,0,0,0,3.27,4.35,14.15,14.15,0,0,0,5.59,1.5c15.93,1.5,30.52,1.73,40.94.53,5.19-.62,9.41-1.64,11.83-3.29a4.31,4.31,0,0,0,2-2.58,3.11,3.11,0,0,0,.1-.86A1,1,0,0,1,673.84,376.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.12,241.31c2.37-2,7.46-1,8.49.61a3.94,3.94,0,0,1,4.91,2.35l5.32,1.88a5.73,5.73,0,0,1,2.49,1.39,2,2,0,0,1,.14,2.61,3,3,0,0,1,.66,4.9,2.1,2.1,0,0,1-.68,3,20.68,20.68,0,0,1,2.75,6.53,4.21,4.21,0,0,1-.08,2.91,1.7,1.7,0,0,1-2.48.69,2.44,2.44,0,0,1-.22,2.63c.93.14,1,1.6.3,2.19a3.36,3.36,0,0,1-2.68.4,4.48,4.48,0,0,0-2.74.12.84.84,0,0,0,.23.63,3.83,3.83,0,0,1,.2,5.28l-.36.39a8.45,8.45,0,0,1-2.92,1.55c-2.23.83-3.45.47-5.82.51.45,1.58-3.76,4.44-7.69.63-15.81,7-18.68-1-18.68-1-4.35,2.86-8.37.69-8.79-.53a3.17,3.17,0,0,1-2.8-1.32,9.51,9.51,0,0,1-1.38-2.91,5.62,5.62,0,0,1-3.38-5.53,6.92,6.92,0,0,1-2-5.22,4.07,4.07,0,0,1-1.64-5.74A24.64,24.64,0,0,1,612.9,253c-1.43-.5-1.74-2.55-1-3.84a7.68,7.68,0,0,1,3.58-2.66c-1.13.15-1.91-1.35-1.51-2.42a4.38,4.38,0,0,1,2.53-2.17,21.18,21.18,0,0,1,4.79-1.45c.77-1.87,3.51-3.76,5.42-4.39,7.72-2.53,12.93-2.77,21.37,5.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.13,268.28a1.61,1.61,0,0,0,.41,0,2.67,2.67,0,0,0,1.13-.31,2.78,2.78,0,0,0,1.27-1.36,2.92,2.92,0,0,0-.09-2.46A7.38,7.38,0,0,0,672,263a3.44,3.44,0,0,1-.79-1.33,2.22,2.22,0,0,1,.3-1.61c.26-.52.63-1,.9-1.59a5,5,0,0,0-2.91-6.85l0,.12a2.49,2.49,0,0,0,.59-1.05,3.14,3.14,0,0,0,.09-1.22,3.57,3.57,0,0,0-.36-1.19,4.35,4.35,0,0,0-.75-1,7.9,7.9,0,0,0-3.16-1.8,12,12,0,0,0-3.4-.6l.07.08a3.63,3.63,0,0,0-1.63-3.4,3.73,3.73,0,0,0-1.74-.59,6.06,6.06,0,0,0-1.72.22,3.83,3.83,0,0,1-.81.08,2,2,0,0,1-.76-.19,6.39,6.39,0,0,1-1.26-.83,5.15,5.15,0,0,0-1.2-.76,4.31,4.31,0,0,0-1.27-.35,4.26,4.26,0,0,0-2.19.3,4.58,4.58,0,0,0-1.38.9,4.82,4.82,0,0,0-.65.81,3.48,3.48,0,0,0-.17.31,2.83,2.83,0,0,0,.19-.3,4.6,4.6,0,0,1,2-1.66,4.45,4.45,0,0,1,3.38.08,5,5,0,0,1,1.18.76,6.47,6.47,0,0,0,1.28.85,2.19,2.19,0,0,0,.8.2,3.41,3.41,0,0,0,.84-.07,5.64,5.64,0,0,1,1.69-.21,3.57,3.57,0,0,1,1.68.56,3.51,3.51,0,0,1,1.55,3.27V245h.08a11.78,11.78,0,0,1,3.36.6,7.69,7.69,0,0,1,3.1,1.76,4.21,4.21,0,0,1,.72,1,3.57,3.57,0,0,1,.34,1.14,3,3,0,0,1-.08,1.16,2.36,2.36,0,0,1-.55,1l-.08.08.11,0a4.9,4.9,0,0,1,2.84,6.65c-.26.57-.63,1.06-.9,1.59a2.38,2.38,0,0,0-.29,1.7,3.44,3.44,0,0,0,.82,1.37,7.47,7.47,0,0,1,.87,1.16,2.78,2.78,0,0,1,.11,2.38,2.67,2.67,0,0,1-1.23,1.34,3,3,0,0,1-1.1.34C670.27,268.29,670.13,268.27,670.13,268.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.36,245.87l0-.09c0-.07,0-.17.06-.28s.14-.63.25-1.09.26-1,.48-1.69a10.17,10.17,0,0,1,1-2.11,6.75,6.75,0,0,1,1.92-2,5.14,5.14,0,0,1,1.41-.63,13.93,13.93,0,0,1,1.65-.24,4.76,4.76,0,0,0,1.69-.5,6.89,6.89,0,0,0,1.47-1.12c.46-.42.9-.87,1.4-1.27a5.29,5.29,0,0,1,1.68-.92,9.18,9.18,0,0,1,3.78-.3,25.29,25.29,0,0,1,3.52.62,18.34,18.34,0,0,1,5.54,2.37,13.28,13.28,0,0,1,3,2.72c.15.2.29.36.39.51l.26.39.17.24.06.08-.05-.09-.15-.24-.25-.4c-.1-.16-.24-.33-.38-.52a12.77,12.77,0,0,0-3-2.78,18.43,18.43,0,0,0-5.57-2.42,23.69,23.69,0,0,0-3.54-.63,9.35,9.35,0,0,0-3.84.3,5.16,5.16,0,0,0-1.72.95c-.51.4-1,.86-1.41,1.28a7.53,7.53,0,0,1-1.44,1.1,4.36,4.36,0,0,1-1.64.48,14.38,14.38,0,0,0-1.66.26,5,5,0,0,0-1.45.65,6.63,6.63,0,0,0-1.94,2.07,10,10,0,0,0-1,2.13c-.21.66-.34,1.23-.45,1.71s-.17.84-.22,1.09,0,.21,0,.28A.82.82,0,0,0,617.36,245.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.11,274.22a1.92,1.92,0,0,1-.49-.21,3.77,3.77,0,0,1-1.11-1,4.61,4.61,0,0,1-.83-2.26,4.11,4.11,0,0,1,.91-3.08l0,.28a4.36,4.36,0,0,1,.2-8l-.1.37a6,6,0,0,1-1-4.79,5.81,5.81,0,0,1,3.32-4,5.88,5.88,0,0,1,2.57-.54l-.27.32a6.15,6.15,0,0,1,8.91-6.72l-.29.11a6.08,6.08,0,0,1,3.31-3.31,5.88,5.88,0,0,1,5.65.7,4.87,4.87,0,0,1,.46.39c.09.1.14.15.13.16a7,7,0,0,0-2.72-1.27,5.56,5.56,0,0,0-3.39.33,5.82,5.82,0,0,0-3.05,3.15l-.09.22-.2-.11a5.9,5.9,0,0,0-5.75.29,5.8,5.8,0,0,0-2.46,5.95l.07.32h-.33a5.47,5.47,0,0,0-2.34.49,5.3,5.3,0,0,0-3,3.65,5.53,5.53,0,0,0,.87,4.39l.18.25-.29.12a4,4,0,0,0-2.48,3.88,4.09,4.09,0,0,0,2.26,3.36l.21.1-.15.18a3.84,3.84,0,0,0-.9,2.81,4.49,4.49,0,0,0,.71,2.18A4.68,4.68,0,0,0,622.11,274.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.52,275.22a2.82,2.82,0,0,1-.64-.62,6.7,6.7,0,0,1-1.22-2.19,6.94,6.94,0,0,1-.17-3.84,7.21,7.21,0,0,1,2.72-4.08l-.06.33a8.35,8.35,0,0,1-1.1-6.76,8.26,8.26,0,0,1,6.11-5.81l-.16.31a7,7,0,0,1-.33-4.23,6.75,6.75,0,0,1,1.54-2.9,6.39,6.39,0,0,1,1.66-1.33,1.94,1.94,0,0,1,.69-.28,9.27,9.27,0,0,0-2.14,1.79,6.49,6.49,0,0,0-1.37,2.81,6.58,6.58,0,0,0,.38,4l.11.26-.27.06a7.77,7.77,0,0,0-4.71,11.85l.13.19-.19.14a6.86,6.86,0,0,0-2.61,3.79,6.77,6.77,0,0,0,.05,3.65A9.13,9.13,0,0,0,637.52,275.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,274.06a4.55,4.55,0,0,0,1.28-1.71,3.37,3.37,0,0,0,.06-2.38,3.49,3.49,0,0,0-2.14-2.14l-.29-.1.2-.24a8.37,8.37,0,0,0,1.75-4.33,7.78,7.78,0,0,0-1.23-5.12,8.28,8.28,0,0,0-4.58-3.43l-.26-.07.09-.25a7.41,7.41,0,0,0,.08-4.76,7.3,7.3,0,0,0-2.06-3.18,9.71,9.71,0,0,0-3-1.73,2.6,2.6,0,0,1,.91.21,7.35,7.35,0,0,1,2.26,1.29,7.58,7.58,0,0,1,2.26,3.28,7.76,7.76,0,0,1,0,5.06l-.16-.32a8.62,8.62,0,0,1,4.89,3.62,8.21,8.21,0,0,1,1.28,5.45,8.56,8.56,0,0,1-1.91,4.55l-.1-.34a3.86,3.86,0,0,1,2.33,2.44,3.63,3.63,0,0,1-.16,2.58,3.49,3.49,0,0,1-1,1.32A1.35,1.35,0,0,1,659,274.06Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M529.16,281.66l-21.07,2.07-.08-18s-1.51-.14-2.46-7.84-2.77-20.76-2.77-20.76h0a28.74,28.74,0,0,1,28.27.3l1.28.74Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.88,248c.13-.08,5.31-2.18,5.72,3.11s-5.17,4.64-5.19,4.49S530.88,248,530.88,248Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.11,249.72c-.14,0-5.15-.77-4.4,4.49s6.07,3.39,6.06,3.24S505.11,249.72,505.11,249.72Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.58,247.2c-.32,4.51.1,6.81-.33,9.85-.68,4.8-2.69,8.65-6.79,11.46s-10,3.43-14.09.67c-2.84-1.92-5-4.21-5.71-7.48s-1.79-9.11-2.18-12.44c-.71-6-1.77-11.73-1.77-11.73l17.47-5.08,10.78,4.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.75,272.17a5.86,5.86,0,0,0,3.15-.08,5.94,5.94,0,0,0,2.88-1.24c-.06-.13-1.34.41-3,.77S516.75,272,516.75,272.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.56,254.81c0-4.59-.22-9.8,0-14.66.07-1.82.45-4.47.08-6.26a14.42,14.42,0,0,0-1.76-5.17,7.82,7.82,0,0,0-5.85-3.44,8.09,8.09,0,0,0-6.42,2.43,6.1,6.1,0,0,0-6.38-1.66,5.87,5.87,0,0,0-3.91,5.19,4.27,4.27,0,0,0-4.91,0,3.94,3.94,0,0,0-1.28,4.59,4,4,0,0,0-2.71,2.53,3.79,3.79,0,0,0,.7,3.56c1,1.13,2.52,1.65,3.56,2.71a4.29,4.29,0,0,1,.8,4.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506,241.19s0,.18.25.47a3.67,3.67,0,0,0,1.16,1,3.78,3.78,0,0,0,2.39.45,4,4,0,0,0,2.72-1.61l-.39,0a3.63,3.63,0,0,0,2.67,2.37,4.44,4.44,0,0,0,4-.93,5.87,5.87,0,0,0,1.94-3.11l-.43.09a5.11,5.11,0,0,0,4.27,1.69,4.76,4.76,0,0,0,3.25-1.71,4.52,4.52,0,0,0,1-2.15,1.92,1.92,0,0,0,0-.85,7.88,7.88,0,0,0-.18.81,4.79,4.79,0,0,1-1.08,2,4.52,4.52,0,0,1-3,1.5,4.74,4.74,0,0,1-3.86-1.58l-.3-.37-.12.46a5.48,5.48,0,0,1-1.8,2.85,4,4,0,0,1-3.51.85,3.22,3.22,0,0,1-2.38-2l-.13-.43-.26.37a3.72,3.72,0,0,1-2.41,1.5,3.64,3.64,0,0,1-2.22-.33A5,5,0,0,1,506,241.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.81,239.09a4.54,4.54,0,0,1,.55-2,3.32,3.32,0,0,1,1.73-1.43,3.54,3.54,0,0,1,2.78.21l.46.25-.1-.51a4,4,0,0,1,0-1.54,4.23,4.23,0,0,1,1.92-2.7,4.37,4.37,0,0,1,2.75-.55,5.78,5.78,0,0,1,2.46,1s-.13-.24-.51-.54a4.3,4.3,0,0,0-1.89-.8,4.45,4.45,0,0,0-5.22,3.49,4.2,4.2,0,0,0,0,1.73l.36-.26a3.93,3.93,0,0,0-3.17-.18,3.58,3.58,0,0,0-1.87,1.67,3.33,3.33,0,0,0-.38,1.58C505.71,238.9,505.78,239.1,505.81,239.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.18,238c.07,0,0-.3-.06-.73a3.42,3.42,0,0,1,.38-1.62,16.28,16.28,0,0,1,.88-1.51c.24-.3.52-.14.56-.17s0-.12-.15-.2a.62.62,0,0,0-.66.13,4.1,4.1,0,0,0-.55.67,6,6,0,0,0-.53.88,2.78,2.78,0,0,0-.28,1.87C516.89,237.8,517.13,238,517.18,238Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527,230.19c.05,0,0-.41-.44-.93a2.58,2.58,0,0,0-.91-.73,2.17,2.17,0,0,0-1.48-.15,3.54,3.54,0,0,0-2,1.55c-.34.53-.48.89-.43.92s.32-.26.72-.72a3.85,3.85,0,0,1,1.85-1.28,2.15,2.15,0,0,1,2,.64C526.74,229.9,527,230.23,527,230.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.72,252.86a8.58,8.58,0,0,0,1.51-3.57,8.37,8.37,0,0,0,.24-3.85c-.15,0-.24,1.71-.73,3.74S526.58,252.8,526.72,252.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.47,254.39a6.41,6.41,0,0,0,1-2.55,6.08,6.08,0,0,0,.36-2.71,9.78,9.78,0,0,0-.84,2.6A9.55,9.55,0,0,0,524.47,254.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.5,256.41a8.09,8.09,0,0,0,1.13,4.56,8.41,8.41,0,0,0,3.14,3.57,28.42,28.42,0,0,1-2.69-3.79A29.22,29.22,0,0,1,509.5,256.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.68,252.83a6.57,6.57,0,0,0,.12,4.21,6.71,6.71,0,0,0,2.26,3.58,24,24,0,0,1-1.78-3.72A22.73,22.73,0,0,1,506.68,252.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "500.27 445.1 491.94 426.62 505.83 420.88 512.82 440.38 507.55 445.42 500.27 445.1",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.65,443.21l-5.38,1.89s-5.39,9.89-4.68,13.81a8.79,8.79,0,0,0,1.13,2.75l12.44-4.72,9-3.7-5.32-12.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.43,
    y: 455.34,
    width: 23.12,
    height: 2.41,
    transform: "translate(-135.93 228.24) rotate(-22.45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.72,445.67c.15,0,.49,2.41,1.18,5.34s1.46,5.26,1.31,5.32a18.74,18.74,0,0,1-1.82-5.2A17.78,17.78,0,0,1,501.72,445.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,450.69a11.41,11.41,0,0,0-2-1.56,6.34,6.34,0,0,0-2.52-.81,6.17,6.17,0,0,0-5.61,2.63,6.56,6.56,0,0,0-1,2.46,11.42,11.42,0,0,0,0,2.5s-.14-.22-.24-.65a5.76,5.76,0,0,1-.09-1.9,6.25,6.25,0,0,1,3.59-4.95,6.3,6.3,0,0,1,3.43-.57,6.24,6.24,0,0,1,2.66,1,5.71,5.71,0,0,1,1.41,1.28C515.94,450.44,516,450.67,516,450.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479,362.33s-8.9,6.76-9.73,12.84a35.74,35.74,0,0,0,1.42,13.9c1,2.59,18,44.17,18,44.17l19.55-8.57L495,385.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "545.38 445.13 552.13 426.01 537.79 421.46 532.48 441.48 538.15 446.06 545.38 445.13",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.86,443.7l5.52,1.43s6.2,9.4,5.83,13.36a8.84,8.84,0,0,1-.91,2.84l-12.79-3.66-9.25-2.92,4.22-13.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.09,
    y: 455.89,
    width: 23.12,
    height: 2.41,
    transform: "translate(915.53 1056.15) rotate(-162.37)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544,445.82a17.75,17.75,0,0,1-.21,5.5,18.05,18.05,0,0,1-1.38,5.33c-.14,0,.43-2.43.86-5.41S543.83,445.81,544,445.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.16,452s.06-.25.3-.63a6,6,0,0,1,1.29-1.39,6.58,6.58,0,0,1,2.58-1.19,6.4,6.4,0,0,1,6.27,2.33,6.22,6.22,0,0,1,1.18,2.58,5.79,5.79,0,0,1,.08,1.9,1.5,1.5,0,0,1-.18.67,12.4,12.4,0,0,0-.26-2.49,6.48,6.48,0,0,0-1.19-2.36,6.07,6.07,0,0,0-2.62-1.86,6,6,0,0,0-3.19-.29,6.24,6.24,0,0,0-2.45,1A12,12,0,0,0,530.16,452Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.55,424.17l11.8-43.9,10.9-20.42s11.24,6.7,13.08,14.09c1.09,4.34-8.69,35.61-8.69,35.61l-6.76,21.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.38,288.75a61.91,61.91,0,0,0-24.29-13.53H506.66l-17.73,9S478.8,289,478.8,303.8s.73,35.84,2.42,39.47a17.71,17.71,0,0,0,3.54,5.24c-.58,8.93-1,15.7-1.16,17.53l68.53,1.54,5.33-67.37A16.1,16.1,0,0,0,553.38,288.75Z",
    style: {
      fill: "#263238"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M490,326.73c-.15,0-.84-5.93-1.55-13.28s-1.18-13.31-1-13.33.84,5.93,1.55,13.28S490.13,326.72,490,326.73Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M546.77,327.64c-.14,0,.16-6.29.69-14s1.06-14,1.2-14-.16,6.29-.68,14S546.91,327.65,546.77,327.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M492.91,388.06a13.44,13.44,0,0,1-13.48-13c-.38-13.65-.39-34.78-.37-43.95a4.5,4.5,0,0,1,4.5-4.49h70.12a4.5,4.5,0,0,1,4.5,4.61c-.23,9.51-.76,31.57-1.1,45.25a11.89,11.89,0,0,1-11.9,11.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,462.79l-4-.48,8.26-67.54a7.82,7.82,0,0,1,7.71-6.95h59.13a7.83,7.83,0,0,1,7.71,6.92c2,16,7.49,67.08,7.54,67.59l-4,.44c0-.52-5.56-51.6-7.53-67.53a3.8,3.8,0,0,0-3.71-3.39H488.93a3.8,3.8,0,0,0-3.71,3.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,462.79s0-.36.11-1.06.2-1.74.36-3.09c.32-2.72.79-6.71,1.4-11.85,1.23-10.28,3-25.15,5.23-43.58.28-2.31.56-4.66.85-7.07a8.94,8.94,0,0,1,.34-1.85,4.11,4.11,0,0,1,1.07-1.6,3.84,3.84,0,0,1,1.72-.92,8.44,8.44,0,0,1,1.93-.11l15.84,0,35,0h7a4,4,0,0,1,2.38.68,4.06,4.06,0,0,1,1.53,2,10.83,10.83,0,0,1,.4,2.41q.27,2.38.54,4.8,1.08,9.66,2.21,19.71c1.49,13.4,3.05,27.3,4.64,41.57l-.29-.23,4-.43-.23.28c-.21-1.84-.43-3.83-.66-5.83-1.46-13.12-2.89-26-4.28-38.43q-1-9.35-2-18.41c-.16-1.5-.33-3-.5-4.5a7.83,7.83,0,0,0-1.49-4,7.61,7.61,0,0,0-3.37-2.59,7.47,7.47,0,0,0-2.08-.47c-.7,0-1.45,0-2.18,0l-33.53,0H490c-.6,0-1.21,0-1.79,0a7.47,7.47,0,0,0-1.7.37,7.35,7.35,0,0,0-2.9,1.81,7.57,7.57,0,0,0-1.81,2.84,14.65,14.65,0,0,0-.61,3.31q-.42,3.36-.81,6.59-.79,6.45-1.53,12.34c-1,7.85-1.85,14.92-2.61,21.12-1.56,12.37-2.67,21.26-3.25,25.87l0-.05,3,.39,1,.14-1-.09-3.05-.35h0v-.05c.55-4.62,1.61-13.51,3.08-25.89.75-6.2,1.6-13.28,2.55-21.13q.7-5.89,1.49-12.35.39-3.23.8-6.58a15.14,15.14,0,0,1,.62-3.4,8,8,0,0,1,1.89-3,8.1,8.1,0,0,1,4.85-2.31c.63,0,1.23,0,1.83,0h22.9l33.53,0c.74,0,1.45,0,2.22,0a8.6,8.6,0,0,1,2.22.5,8.11,8.11,0,0,1,3.59,2.75,8.42,8.42,0,0,1,1.59,4.28c.17,1.49.33,3,.5,4.5q1,9.06,2.06,18.41c1.39,12.47,2.83,25.32,4.29,38.44.23,2,.45,4,.65,5.83l0,.25-.26,0-4,.43-.26,0,0-.26c-1.58-14.26-3.13-28.16-4.62-41.56q-1.12-10.05-2.2-19.71c-.18-1.61-.35-3.21-.53-4.8a11,11,0,0,0-.37-2.3,3.58,3.58,0,0,0-1.36-1.73,3.44,3.44,0,0,0-2.1-.6h-7l-35,0-15.84,0a7.9,7.9,0,0,0-1.84.1,3.53,3.53,0,0,0-1.55.82,3.67,3.67,0,0,0-1,1.46,7.53,7.53,0,0,0-.32,1.75q-.45,3.63-.88,7.1c-2.3,18.45-4.15,33.35-5.43,43.64-.65,5.12-1.15,9.09-1.49,11.8l-.39,3C477,462.45,477,462.79,477,462.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.05,375.83a1.16,1.16,0,0,1,0,.3,2.61,2.61,0,0,1-.05.89,4.37,4.37,0,0,1-2,2.75c-2.48,1.76-6.76,2.85-12,3.52-10.56,1.31-25.28,1.14-41.4-.38a14.77,14.77,0,0,1-5.84-1.58,7.92,7.92,0,0,1-3.53-4.69,27.45,27.45,0,0,1-.93-5.58c-.17-1.82-.34-3.61-.5-5.36-.6-7-1-13.3-1.14-18.6s-.24-9.59-.25-12.55c0-1.48,0-2.64,0-3.42,0-.36,0-.66,0-.88a1.92,1.92,0,0,1,0-.31,1.3,1.3,0,0,1,0,.31c0,.22,0,.52,0,.88,0,.82,0,2,.07,3.42.06,3,.16,7.25.41,12.54s.62,11.59,1.25,18.57c.17,1.74.34,3.53.51,5.35a27.08,27.08,0,0,0,.93,5.48,7.33,7.33,0,0,0,3.3,4.39,14.18,14.18,0,0,0,5.63,1.51c16.08,1.52,30.79,1.74,41.31.54,5.23-.63,9.49-1.66,11.93-3.33a4.32,4.32,0,0,0,2-2.6,2.73,2.73,0,0,0,.09-.87A1.16,1.16,0,0,1,550.05,375.83Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.9,359.73l.3,16.77s-16.94,5.93-17.19,9l32.53.59.61-26.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.28,375.27a1.32,1.32,0,0,1,.89,1.53,1.28,1.28,0,0,1-1.51.9,1.4,1.4,0,0,1-.93-1.63,1.33,1.33,0,0,1,1.67-.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.54,386.13l-.05-2.64-31.17.42s-1.45.6-1.31,1.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.67,376.32c0,.16.8.25,1.57.77s1.18,1.2,1.32,1.14-.07-1-1-1.6S384.64,376.18,384.67,376.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.24,377.67c0,.15.64.44,1.17,1.12s.67,1.39.83,1.39.27-.9-.4-1.74S381.24,377.52,381.24,377.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.22,381.72c.15,0,.38-.75,0-1.63s-1.13-1.24-1.2-1.11.38.61.7,1.33S379.07,381.7,379.22,381.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,372.49c.06.15.8-.06,1.69,0s1.59.38,1.68.24-.58-.71-1.64-.79S385,372.37,385,372.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.58,358.71l1.77,20.21-3.22,16.38a2.07,2.07,0,0,0,1.78,2.46h0a2,2,0,0,0,1.79-.65c2.9-3.16,13.5-14.84,13.29-16.31-.24-1.71-.44-21.44-.44-21.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.91,397.76l15-18.33.06.86a3.13,3.13,0,0,1-.61,2.07c-1.19,1.59-4.57,5.92-12.59,14.75a2.08,2.08,0,0,1-1.85.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.33,373.17a1.26,1.26,0,0,0-.24,1.66,1.22,1.22,0,0,0,1.65.25,1.32,1.32,0,0,0,.24-1.76,1.25,1.25,0,0,0-1.74-.07",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M429,388.62a6.27,6.27,0,0,0-1.88-1.46,6.54,6.54,0,0,0-2.36-.3s.23-.22.7-.31a3.22,3.22,0,0,1,1.83.2,3.16,3.16,0,0,1,1.44,1.15C429,388.3,429,388.6,429,388.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.7,391.42a18.11,18.11,0,0,0-1.85-.75,17.86,17.86,0,0,0-2-.13,2.28,2.28,0,0,1,2.09-.3C427.17,390.51,427.8,391.36,427.7,391.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.43,385a21.58,21.58,0,0,0-2.78-1.35,19.08,19.08,0,0,0-3-.51,4.6,4.6,0,0,1,3.18.08A4.67,4.67,0,0,1,431.43,385Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41,378.79c-.05.12-1.2-.27-2.66-.23s-2.59.46-2.64.34a5.15,5.15,0,0,1,5.3-.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,372.84a10.15,10.15,0,0,0-2.76-.31,9.68,9.68,0,0,0-2.64.85s.17-.31.62-.61a4.54,4.54,0,0,1,4.05-.4C430.81,372.57,431.07,372.8,431,372.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.25,371.4a1.71,1.71,0,0,1-.08-.77,5.27,5.27,0,0,1,.48-2,2.37,2.37,0,0,1,.94-1.19.82.82,0,0,1,1,.12,1.35,1.35,0,0,1,.38.9,2.93,2.93,0,0,1-2.39,2.87,3.42,3.42,0,0,1-3.46-1.56,1.23,1.23,0,0,1-.12-1,.83.83,0,0,1,.83-.49,2.93,2.93,0,0,1,1.38.61,6.17,6.17,0,0,1,1.48,1.48,2,2,0,0,1,.36.68,9.73,9.73,0,0,0-2-1.9,2.74,2.74,0,0,0-1.21-.5.43.43,0,0,0-.45.26.81.81,0,0,0,.11.64,3,3,0,0,0,3,1.32,2.54,2.54,0,0,0,2.07-2.41.92.92,0,0,0-.24-.63.44.44,0,0,0-.52-.08,2.14,2.14,0,0,0-.81,1A7.82,7.82,0,0,0,428.25,371.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.09,219.75a72.23,72.23,0,0,0-1.57,21.18c.35,4.5,15.54,129.05,15.54,129.05h20.51L397.8,252.92l1.68.37s11.2,49.92,12.11,58c.83,7.27,10.27,60,10.27,60l18.75.21-6-69.81-7-67L425,215.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,241a3.89,3.89,0,0,1-.86.48,9.69,9.69,0,0,1-2.54.89,5.18,5.18,0,0,1-1.89,0,3.89,3.89,0,0,1-2-1,4.69,4.69,0,0,1-1.2-2.1c-.24-.79-.38-1.62-.55-2.46-.65-3.38-1.1-6.47-1.36-8.71-.13-1.12-.21-2-.26-2.65a4.32,4.32,0,0,1,0-1,4.57,4.57,0,0,1,.19,1c.11.71.24,1.59.4,2.63.33,2.23.82,5.3,1.48,8.66.33,1.67.55,3.36,1.59,4.36a4.26,4.26,0,0,0,3.54.92,11.26,11.26,0,0,0,2.52-.74A4.9,4.9,0,0,1,401,241Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.87,225.11s.13-.11.42-.13a1.85,1.85,0,0,1,1.14.37,2,2,0,0,1,.87,1.58A1.93,1.93,0,0,1,396,228.7a1.91,1.91,0,0,1-2.14-.47,2,2,0,0,1-.39-1.76,1.8,1.8,0,0,1,.62-1c.23-.18.39-.2.4-.18a2.2,2.2,0,0,0-.72,1.27,1.77,1.77,0,0,0,.39,1.44,1.66,1.66,0,0,0,2.76-1,1.79,1.79,0,0,0-.66-1.34A2.31,2.31,0,0,0,394.87,225.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.37,233.55a2.19,2.19,0,0,1-.7.11,12.87,12.87,0,0,1-1.92,0,18.62,18.62,0,0,1-11.52-4.85,12.13,12.13,0,0,1-1.33-1.39,2.43,2.43,0,0,1-.41-.58c.06-.05.72.71,1.94,1.74a20.66,20.66,0,0,0,11.34,4.77C426.36,233.53,427.36,233.47,427.37,233.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.93,224.81a8.46,8.46,0,0,1-1.06,2.09,23.58,23.58,0,0,1-3.56,4.41,23.89,23.89,0,0,1-4.51,3.44,8.63,8.63,0,0,1-2.12,1,22,22,0,0,1,2-1.26A30.47,30.47,0,0,0,374,231a29.13,29.13,0,0,0,3.6-4.27C378.43,225.55,378.87,224.78,378.93,224.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.73,82.18l.81-.05a15.86,15.86,0,0,1,16.61,13.64c1.05,7.61,2.12,16,2.31,20.12.38,8.5-8,10.31-8,10.31l.3,3.45a10.33,10.33,0,0,1-9.44,11.19h0a10.32,10.32,0,0,1-11.13-9.3l-3-31.52C379.88,91.25,383.92,83.2,392.73,82.18Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.5,126.18a20.62,20.62,0,0,1-11.31-2.61s3,6,11.39,4.7Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.77,103.66a1.21,1.21,0,0,1-1.1,1.29,1.16,1.16,0,0,1-1.31-1,1.21,1.21,0,0,1,1.1-1.29A1.16,1.16,0,0,1,407.77,103.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.56,100c-.14.16-1.1-.46-2.4-.38s-2.22.78-2.37.63.06-.36.46-.69a3.32,3.32,0,0,1,1.89-.7,3.23,3.23,0,0,1,1.92.5C408.48,99.67,408.63,100,408.56,100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.49,104.46a1.21,1.21,0,0,1-1.1,1.29,1.16,1.16,0,0,1-1.31-1,1.21,1.21,0,0,1,1.1-1.29A1.16,1.16,0,0,1,396.49,104.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.75,101c-.14.16-1.1-.46-2.4-.38s-2.22.78-2.37.63.06-.36.46-.69a3.35,3.35,0,0,1,1.89-.7,3.23,3.23,0,0,1,1.92.5C395.67,100.66,395.82,100.93,395.75,101Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,110.41a9,9,0,0,1,2.1-.5c.33-.06.64-.14.69-.37a1.78,1.78,0,0,0-.28-1c-.36-.79-.74-1.61-1.13-2.48a44,44,0,0,1-2.6-6.5c.15-.07,1.54,2.75,3.11,6.28.38.87.75,1.7,1.09,2.5a1.9,1.9,0,0,1,.25,1.29.82.82,0,0,1-.52.52,2.12,2.12,0,0,1-.56.11A8.72,8.72,0,0,1,401,110.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,95.88c-.11.36-1.42.27-2.94.54s-2.74.76-3,.45c-.1-.14.1-.49.58-.86a5,5,0,0,1,2.16-.9,4.93,4.93,0,0,1,2.33.14C395.54,95.44,395.84,95.71,395.8,95.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.86,96.28c-.21.31-1.12,0-2.21.1s-2,.32-2.21,0,0-.45.41-.76a3.25,3.25,0,0,1,3.57-.09C407.81,95.83,408,96.13,407.86,96.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.11,91.92s-2.55-5.18-5.18-6.28c-3.19-1.32-4.33,2.16-7.34,1.51s-6-1.93-8.94.53c-3.16,2.69-1.51,4.36-1.5,8.14.05,15.31-2.49,19.79-3.7,12.65-.13-.79-2.35-1.29-2.87-4.6-.66-4.29-1.13-9.52-.34-12.64.66-2.63,2-4.5,4.56-6.62,4-3.34,9.71-3.74,13.62-3.57S409.08,85.25,409.11,91.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,108.2a2.3,2.3,0,0,0-2.61-2.07c-1.58.24-3.29,1.24-3,4.5.51,5.8,6.22,4.08,6.22,3.91S383.22,110.63,383,108.2Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.14,112.48s-.09.08-.26.17a1,1,0,0,1-.75.08,2.49,2.49,0,0,1-1.35-2.13,3.22,3.22,0,0,1,.15-1.47,1.19,1.19,0,0,1,.69-.85.51.51,0,0,1,.62.23c.09.15.06.27.1.28s.11-.11,0-.35a.61.61,0,0,0-.26-.34.78.78,0,0,0-.57-.1,1.44,1.44,0,0,0-1,1,3.4,3.4,0,0,0-.21,1.64,2.61,2.61,0,0,0,1.7,2.37,1.1,1.1,0,0,0,.91-.23C382.14,112.62,382.16,112.48,382.14,112.48Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.34,85.64c-.89-.67-2.12-.76-3-1.44-1.61-1.24-1.68-4-3.57-4.78-1.12-.44-2.38.1-3.58,0-1.94-.21-2.69-1.67-5.63-1.68a5.35,5.35,0,0,0-5.05,2.84,4.39,4.39,0,0,0-4.4.42,4.87,4.87,0,0,0-1.84,3.51s-.6-.31-2.44,1.14A9.54,9.54,0,0,0,378.28,90c-.63,2.12.29,4.36,1.19,6.39.49,1.09,1.1,2.3,2.23,2.68,1.39.47,2.92-.62,3.46-2s1.39-2.72,2-4c1.14-2.26,2.31-4.38,1.35-5.83a6.61,6.61,0,0,1,4.08,0c1.33.44,2.49,1.29,3.82,1.76s3,.44,3.89-.64a2.85,2.85,0,0,0,4.36,1,4,4,0,0,0,5.19,1.46A3.22,3.22,0,0,0,410.34,85.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.89,95a7.09,7.09,0,0,1,.67,1.33,2.85,2.85,0,0,0,1,1.17,2.46,2.46,0,0,0,1.8.21,4.4,4.4,0,0,0,1.74-.73,7.41,7.41,0,0,0,1.13-1.09,7.35,7.35,0,0,1,1-1.13,5.13,5.13,0,0,1-.78,1.28,6.15,6.15,0,0,1-1.13,1.19,4.37,4.37,0,0,1-1.87.82,2.77,2.77,0,0,1-2-.28,2.88,2.88,0,0,1-1-1.34A6.06,6.06,0,0,1,378.89,95Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.11,99.47a4.36,4.36,0,0,0,1.15.64,3.36,3.36,0,0,0,1.38.12,4.06,4.06,0,0,0,1.6-.61,8,8,0,0,0,2.18-2.3,6,6,0,0,1,.79-1.1,4.69,4.69,0,0,1-.58,1.23,7.12,7.12,0,0,1-2.21,2.46,4,4,0,0,1-1.74.63,3.25,3.25,0,0,1-1.51-.2C379.35,100,379.08,99.48,379.11,99.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.34,112.54a7.12,7.12,0,0,0-.33,2,2.25,2.25,0,0,0,.63,1.71,2.44,2.44,0,0,0,1.88.86h0a2.7,2.7,0,0,0,2.67-2.3l.23-1.44C401.09,113,397.44,112.64,397.34,112.54Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.91,116.66s-.17,0-.46,0a4.1,4.1,0,0,1-1.23,0,2.38,2.38,0,0,1-1.49-.88,2.94,2.94,0,0,1-.59-2,3,3,0,0,1,.31-1.18l-.18.09c1.31.2,2.45.35,3.26.45a4.87,4.87,0,0,0,1.32.09,6.39,6.39,0,0,0-1.28-.31c-.81-.16-1.94-.36-3.24-.57l-.13,0-.05.11a3.05,3.05,0,0,0-.36,1.32,3.14,3.14,0,0,0,.69,2.26,2.52,2.52,0,0,0,1.71.91,3.33,3.33,0,0,0,1.28-.12C400.77,116.76,400.92,116.68,400.91,116.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.33,108.88a1.19,1.19,0,0,0-1.64-.56c-.66.37-.79.9-1,1.63a2,2,0,0,0,.2,1.56,1.28,1.28,0,0,0,1.38.56,1.8,1.8,0,0,0,1-1.28A2.53,2.53,0,0,0,382.33,108.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.64,119a12.49,12.49,0,0,1-5.21-1.12,12.72,12.72,0,0,1-6.83-7.89l1-.28a11.54,11.54,0,0,0,15.88,7.26l.42.91A12.53,12.53,0,0,1,392.64,119Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.59,116h2.12a1.6,1.6,0,0,1,1.6,1.6v.06a1.59,1.59,0,0,1-1.59,1.59h-2.12a1.6,1.6,0,0,1-1.6-1.6v-.06a1.59,1.59,0,0,1,1.59-1.59Z",
    transform: "translate(-15.22 78.97) rotate(-11.13)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.22,109.84a4.81,4.81,0,0,0,1.16-1.71,2.36,2.36,0,0,0-.13-2,2.86,2.86,0,0,0-1.43-1.05,3.52,3.52,0,0,0-1.53-.28,1.85,1.85,0,0,0-1.36.69.68.68,0,0,0-.08.8c.21.25.6.18.92.1a3.69,3.69,0,0,1,1.32-.16,1.48,1.48,0,0,1,1.12.63,1.54,1.54,0,0,1,0,1.47,4.4,4.4,0,0,1-1,1.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.76,140.66c-.5,0-7.69,2.87-9.58,9.94s-7.05,32.91-7.05,32.91l-5.48,7.58s1.77,13.86,11.85,11.23c0,0,6.73,1.17,8.88-5.65s6.3-27.16,6.3-27.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.74,128.83l-3.81,5.76-17.17,6.07,4.92,49.79-1.84,26.09a5.88,5.88,0,0,0,6,6.3l54-1.59c1.35,0,2-1.75,2.2-3.59a12.28,12.28,0,0,0-.43-4.93l-2.84-10c.42,6.21-1.44-37-1.51-38.62l4.16-22.26L407.88,134l-3-4.67L396.07,136Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.42,141.86s3.93,3.45,4.59,6.08,14.78,33.24,14.78,33.24l7,1.9,1.87,3.88a10.82,10.82,0,0,1-3.06,13.31c-.26.2-.51.37-.75.52a12,12,0,0,1-14.58-2.53c-3.77-4.43-14.78-20.4-14.78-20.4V158.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.43,184.27l10.1-6,4.86,6-1,2.89-13,9.65a8.65,8.65,0,0,1-3-5.23C447.75,188,450.43,184.27,450.43,184.27Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.23,181.19c0,.1-.86,0-2.13.43a9.46,9.46,0,0,0-4.19,2.91,18.79,18.79,0,0,0-2.67,4.48,11.83,11.83,0,0,1-.95,2,7.54,7.54,0,0,1,.61-2.13,16,16,0,0,1,2.61-4.67,8.88,8.88,0,0,1,4.49-2.92A4,4,0,0,1,447.23,181.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.36,181.62a7.84,7.84,0,0,1,2.42-7.27,27.28,27.28,0,0,1,8-4.57c1.77-.79,5.45-3.87,6.11-3.12a2.44,2.44,0,0,1,0,3.21c-.93,1.36-6.27,3.39-5.53,5.1.31.7,2,.82,2,.82s6.44.42,9.14.19,5.13.28,5,1.21-.65,1.45-2.89,1.63-5.87.05-6.06.56.56.84,1.86.75,7.46-.1,7.88.6a1.4,1.4,0,0,1-.74,2l-1.45.51s.84,1.17.14,1.82-2.28.42-2.28.42l-8.16-.23s-.47.49-.23.82,6.61-.13,6.66.57.61,1-1.3,1.5a26,26,0,0,1-8.44,0,83.89,83.89,0,0,0-8.95-.8Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.51,185.34l-9.43-7.84-5.42,6.09.66,3,11.8,11.1a8.16,8.16,0,0,0,3.7-4.52C352,189.82,349.51,185.34,349.51,185.34Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,181.55a7.9,7.9,0,0,0-1.56-7.51,27.29,27.29,0,0,0-7.39-5.46c-1.67-1-5-4.48-5.7-3.82A2.45,2.45,0,0,0,325,168c.76,1.45,4.43,3.15,4.3,5a1.38,1.38,0,0,1-1.48,1.28,90.86,90.86,0,0,1-9.09-.88c-2.66-.55-5.13-.32-5.1.62s.48,1.51,2.68,2,5.83.73,6,1.26-.66.77-1.94.52-7.4-1-7.9-.31a1.4,1.4,0,0,0,.51,2.08l1.38.67s-1,1.06-.35,1.79,2.22.69,2.22.69l8.12.72s.41.54.14.85-6.56-.9-6.69-.22-.72.95,1.13,1.64a25.78,25.78,0,0,0,8.37,1,84.87,84.87,0,0,1,9,.26Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.4,135.38a13.83,13.83,0,0,1-1.7,1.77c-1.07,1-2.55,2.52-4.11,4.2-.32.36-.65.71-1,1.05l-.2.23-.19-.24c-1.21-1.55-2.25-2.93-3-3.93a8.69,8.69,0,0,1-1.1-1.66,8.42,8.42,0,0,1,1.36,1.45c.8.95,1.9,2.28,3.12,3.82h-.39l1-1.06a55.06,55.06,0,0,1,4.24-4.12A9.88,9.88,0,0,1,407.4,135.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.88,153.86a5.16,5.16,0,0,1,.28,1.06c.15.68.33,1.68.52,2.92.4,2.47.83,5.9,1.18,9.71s.61,7.24.8,9.73c.08,1.16.15,2.15.21,3a4.57,4.57,0,0,1,0,1.09,4.4,4.4,0,0,1-.22-1.07c-.11-.69-.23-1.7-.38-2.94-.28-2.49-.6-5.93-1-9.73s-.71-7.22-1-9.7L364,155A3.9,3.9,0,0,1,363.88,153.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.57,152.13a6.42,6.42,0,0,1,.19,1.32c.08.86.18,2.1.26,3.64.17,3.07.26,7.32.27,12v15.65a5.78,5.78,0,0,1-.06,1.33,6.42,6.42,0,0,1-.14-1.33c-.06-.85-.12-2.1-.17-3.64-.11-3.07-.14-7.32-.15-12s0-8.93-.12-12c0-1.45-.07-2.67-.09-3.63A7,7,0,0,1,423.57,152.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.13,196.15a19.6,19.6,0,0,1-.53-2.64,20.62,20.62,0,0,0-2-6.07,11.36,11.36,0,0,0-4.41-4.47,21.22,21.22,0,0,0-2.48-1,1.86,1.86,0,0,1,.73,0,6.71,6.71,0,0,1,1.91.6,10.76,10.76,0,0,1,4.7,4.55,18,18,0,0,1,2,6.26A10.61,10.61,0,0,1,356.13,196.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.58,185.84a19.38,19.38,0,0,0-4.09-2.26,20.13,20.13,0,0,0-4.63-.72,7.34,7.34,0,0,1,4.8.23A7.23,7.23,0,0,1,358.58,185.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.3,221.3a4.8,4.8,0,0,1-.06-.85c0-.61,0-1.42-.05-2.45-.05-2.17-.11-5.23-.18-9-.18-7.64-.43-18.11-.7-29.68s-.42-22.08-.41-29.68c0-3.8,0-6.88.09-9,0-1,.06-1.84.07-2.45s.05-.85.06-.85a4.46,4.46,0,0,1,.05.86c0,.6,0,1.42,0,2.44,0,2.18.05,5.24.08,9,.08,7.59.3,18.08.56,29.67s.49,22.08.55,29.68c0,3.8,0,6.87,0,9,0,1,0,1.84,0,2.45A5.74,5.74,0,0,1,397.3,221.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.05,185a4,4,0,0,1,1.38,1.78,8.8,8.8,0,0,1,.8,2.33,9.49,9.49,0,0,1,0,3,8.07,8.07,0,0,1-.88,2.9,5.74,5.74,0,0,1-1.65,1.86,3.22,3.22,0,0,1-2.12.76,9,9,0,0,0,1.89-1.06,5.84,5.84,0,0,0,1.46-1.79,8.61,8.61,0,0,0,.79-2.74,10.2,10.2,0,0,0,0-2.87,10,10,0,0,0-.66-2.26A20,20,0,0,0,349.05,185Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.26,197.9s-.24,0-.63-.19a7,7,0,0,1-1.53-.92A8.27,8.27,0,0,1,449,186a7,7,0,0,1,1.08-1.43c.3-.3.5-.44.52-.41s-.61.71-1.27,2a8.38,8.38,0,0,0,2,10.3C452.43,197.47,453.3,197.81,453.26,197.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.71,175a7.88,7.88,0,0,1-1.31.77c-.85.46-2.1,1.1-3.66,1.88-3.11,1.55-7.46,3.59-12.35,5.66s-9.38,3.77-12.66,4.93c-1.64.58-3,1-3.9,1.32a7.6,7.6,0,0,1-1.46.4,9.63,9.63,0,0,1,1.39-.59l3.84-1.48c3.25-1.24,7.71-3,12.59-5.06s9.24-4.05,12.39-5.51l3.73-1.73A8.78,8.78,0,0,1,414.71,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.63,172.73c.06.06-.37.48-.93,1.22a3.5,3.5,0,0,0-.65,1.43c-.12.59-.11,1.28-.21,2a4.93,4.93,0,0,1-1.95,3.28,2.5,2.5,0,0,1-1.45.63c0-.08.53-.3,1.22-.91a5.12,5.12,0,0,0,1.66-3.07c.1-.7.1-1.41.26-2.06a3.56,3.56,0,0,1,.83-1.56C472.08,173,472.59,172.69,472.63,172.73Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.51,180.75a24.75,24.75,0,0,1-5.68.13,25.23,25.23,0,0,1-5.64-.66,40,40,0,0,1,5.67.14A43.37,43.37,0,0,1,325.51,180.75Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.29,180.32c0,.06-.61,0-1.33-.65a4.18,4.18,0,0,1-1.43-3.26,10,10,0,0,1,.35-1.92,5.26,5.26,0,0,0,.19-1.48,5,5,0,0,0-.31-1.35s.56.35.68,1.31a4.8,4.8,0,0,1-.09,1.62,13.58,13.58,0,0,0-.3,1.84,4.19,4.19,0,0,0,1.17,3C330.81,180,331.32,180.24,331.29,180.32Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.09,182.13a34.08,34.08,0,0,1,6.05.24,35.88,35.88,0,0,1,6,.76,35.26,35.26,0,0,1-6.05-.24A35.88,35.88,0,0,1,474.09,182.13Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.54,136.3a18.67,18.67,0,0,1-1.15,3l-.63,1.47a16.86,16.86,0,0,1-.81,1.69,1.09,1.09,0,0,1-1.07.53,2.67,2.67,0,0,1-1-.52l-1.8-1.23c-2.46-1.7-4.66-3.26-6.25-4.41a21.16,21.16,0,0,1-2.5-1.94,19,19,0,0,1,2.71,1.64c1.64,1.07,3.88,2.58,6.34,4.28l1.79,1.24a2.64,2.64,0,0,0,.8.45.61.61,0,0,0,.6-.31c.58-1.06,1.06-2.19,1.5-3.05A21.17,21.17,0,0,1,395.54,136.3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-142"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "226.67 448.11 226.03 427.85 241.07 427.85 240.07 448.54 233.28 451.19 226.67 448.11",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.36,448.42l-5.69-.31s-8.75,7.09-9.6,11a8.73,8.73,0,0,0,0,3l13.3.39h9.7V448.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.95,
    y: 460.05,
    width: 23.12,
    height: 2.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.79,449.19c.15,0-.46,2.42-.94,5.39S226.18,460,226,460a25.79,25.79,0,0,1,1.76-10.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.09,459.29a12,12,0,0,0-1.21-2.19,6.45,6.45,0,0,0-2-1.71,6.15,6.15,0,0,0-3.13-.68,6.06,6.06,0,0,0-3.06,1,6.53,6.53,0,0,0-1.86,1.9,12.11,12.11,0,0,0-1,2.29,1.42,1.42,0,0,1,0-.7,5.68,5.68,0,0,1,.65-1.78,6.36,6.36,0,0,1,8.59-2.42,6.41,6.41,0,0,1,2.09,1.91,5.54,5.54,0,0,1,.81,1.72A1.46,1.46,0,0,1,239.09,459.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.81 448.73 268.8 428.68 253.87 426.93 252.45 447.59 258.88 451.02 265.81 448.73",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.12,448.37l5.68.35s7.88,8.07,8.26,12a8.57,8.57,0,0,1-.35,3l-13.25-1.16c-2.66-.32-9.64-1.12-9.64-1.12l1.63-13.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.89,
    y: 460.36,
    width: 23.12,
    height: 2.41,
    transform: "translate(469.3 950.58) rotate(-173.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.57,449.67a18.49,18.49,0,0,1,.83,5.44,18.29,18.29,0,0,1-.34,5.49c-.15,0,0-2.46-.18-5.47S264.42,449.69,264.57,449.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.17,458.38s0-.26.17-.67a5.83,5.83,0,0,1,1-1.61,6.19,6.19,0,0,1,5.76-2,6.25,6.25,0,0,1,3.15,1.48,6.31,6.31,0,0,1,1.64,2.3,5.65,5.65,0,0,1,.44,1.85,1.57,1.57,0,0,1,0,.7,12.72,12.72,0,0,0-.72-2.4,6.48,6.48,0,0,0-1.63-2.09,6,6,0,0,0-2.92-1.33,6.14,6.14,0,0,0-3.19.32,6.45,6.45,0,0,0-2.21,1.46A12.3,12.3,0,0,0,252.17,458.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.47,385c0,.89,3.38,49.81,3.38,49.81H243.5l2.31-50.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.87 384.32 271.19 435.9 250 434.19 251.37 382.88 276.87 384.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.88,224.82l-.41-.16a8.11,8.11,0,0,0-6.09-4.75,10.53,10.53,0,0,0-7.64,1.8c-1.54,1-2.83,2.45-4.38,3.49a6.15,6.15,0,0,1-5.28,1.12c-.3.65.91,1.21.74,1.9a.85.85,0,0,1-.79.54,9.52,9.52,0,0,1-1.49-.2,1.18,1.18,0,0,0-1.27.58,1.35,1.35,0,0,0,0,.72,13,13,0,0,0,2.21,6.13,6.78,6.78,0,0,0,5.63,2.88,10.73,10.73,0,0,0,4.82-2l8.52-5.23a17.72,17.72,0,0,0,3.69-2.73A5.94,5.94,0,0,0,257.88,224.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.22,225.05a8.5,8.5,0,0,1,3.82-1.33,5.1,5.1,0,0,1,3.79,1.23,11.27,11.27,0,0,1,2,3.21,4.72,4.72,0,0,0,2.64,2.59,1.05,1.05,0,0,1,.59.28c.25.3,0,.8-.4.92a1.86,1.86,0,0,1-1.15-.16,4.12,4.12,0,0,0,2.26,1.67,1.79,1.79,0,0,1-2.34,1,18.19,18.19,0,0,1,.16,4.54,6.17,6.17,0,0,1-2,4c-1.28,1.08-3.19,1.53-3.89,3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.69,276.77,258.86,279l-.09-17.43s1.41-.12,2.44-7.57,3-20.08,3-20.08h0a26.11,26.11,0,0,0-26.46,0l-1.22.71Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.68,244.14c-.12-.07-4.94-2.16-5.41,3s4.76,4.55,4.78,4.4S237.68,244.14,237.68,244.14Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.77,246.09c.13,0,4.83-.7,4,4.38s-5.74,3.23-5.72,3.08S261.77,246.09,261.77,246.09Z",
    style: {
      fill: "#ae7461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.1,243.37c.22,4.37-.21,6.59.14,9.54.55,4.65,2.35,8.4,6.14,11.17s9.3,3.41,13.18.78c2.69-1.82,4.71-4,5.48-7.18s2.46-9.07,2.89-12.3c.77-5.82,1.23-11.06,1.23-11.06l-16.26-5.1-10.17,4.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.47,267.71a5.46,5.46,0,0,1-2.95-.11,5.28,5.28,0,0,1-2.67-1.24c.06-.12,1.24.42,2.78.78S250.47,267.57,250.47,267.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,250.73c.06-4.44.37-9.49.27-14.19,0-1.77-.34-4.34,0-6.07s.79-1.13,1.76-2.62c1.21-1.86,5.08-2.72,7.29-2.88s2.72-2,4.2-.34a5.45,5.45,0,0,1,9.56,3.52,3.78,3.78,0,0,1,5.72,4.54,3.73,3.73,0,0,1,2.48,2.48,3.78,3.78,0,0,1-.71,3.44c-.92,1.09-2.4,1.57-3.39,2.59a4.3,4.3,0,0,0-.83,4.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.54,252.51a9.81,9.81,0,0,1-4.15,7.84,28.48,28.48,0,0,0,2.59-3.64A29.47,29.47,0,0,0,257.54,252.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.24,249.07a7.92,7.92,0,0,1-2.37,7.53,22.57,22.57,0,0,0,1.74-3.59A21.9,21.9,0,0,0,260.24,249.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5,228.81a11.47,11.47,0,0,1,5.78-4,6.72,6.72,0,0,1,6.58,1.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5,240.15c.09,0,.08-.59,0-1.52a20.09,20.09,0,0,1,.06-3.59,7.75,7.75,0,0,1,1.19-3.28c.5-.76.95-1.12.9-1.2s-.61.2-1.24.94A6.88,6.88,0,0,0,240,235a12.48,12.48,0,0,0,.11,3.71A4.1,4.1,0,0,0,240.5,240.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.73,242.27a35.26,35.26,0,0,0-.89-4.85,4,4,0,0,0-.06,2.52A4.09,4.09,0,0,0,243.73,242.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.88,243a4.42,4.42,0,0,0,1.37-1.68,9.05,9.05,0,0,0-.73-10c-.84-1.07-1.56-1.52-1.6-1.46s.55.62,1.26,1.7a10,10,0,0,1,1.62,4.7,9.89,9.89,0,0,1-.93,4.88C260.33,242.27,259.8,242.91,259.88,243Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.07,221.71a7.1,7.1,0,0,0,1.73-.49,9.81,9.81,0,0,1,4.14-.48,4.91,4.91,0,0,1,3.44,2,11.22,11.22,0,0,1,.75,1.57c.06,0,.18-.75-.39-1.79a4.49,4.49,0,0,0-1.39-1.49,5.44,5.44,0,0,0-2.33-.87,8.52,8.52,0,0,0-4.36.68A4.34,4.34,0,0,0,244.07,221.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.23,229.29c.07,0,0-.6-.42-1.42a5.55,5.55,0,0,0-6.25-2.7c-.9.24-1.36.61-1.33.67a9.32,9.32,0,0,0,1.41-.26,5.9,5.9,0,0,1,5.81,2.51C266,228.8,266.14,229.32,266.23,229.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.39,247.35c0-.07-.79-.4-2.05-1.17a17.48,17.48,0,0,1-4.51-4l-.85-1,.37,1.31a10.54,10.54,0,0,1,.42,2.51c0,.43,0,1-.14,1s-.55-.17-.9-.49a15.27,15.27,0,0,1-3-3.46l-.76-1.17.24,1.37c.24,1.36.47,2.64.67,3.79l.41-.18a22.71,22.71,0,0,1-2.74-4.52,4.19,4.19,0,0,0,.4,1.4,13.92,13.92,0,0,0,2,3.41l.54.7-.13-.88c-.17-1.16-.37-2.44-.57-3.81l-.52.19a15.29,15.29,0,0,0,3.14,3.62,5.38,5.38,0,0,0,.61.46,1,1,0,0,0,1,.08,1,1,0,0,0,.44-.84c0-.27,0-.48,0-.72a11.12,11.12,0,0,0-.47-2.64l-.48.25a16.11,16.11,0,0,0,4.77,3.89A6.77,6.77,0,0,0,258.39,247.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.12,226.46a2.65,2.65,0,0,1,1.77-1,4.61,4.61,0,0,1,2.08.21,7.44,7.44,0,0,1,4,3.06c.21.32.38.81.08,1.06a.83.83,0,0,1-.6.13,32.8,32.8,0,0,1-7.49-1.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.76,277.77s-20.9,5.33-24.38,10.86-5.53,18.23-5.53,20.49-.41,27.86,3.89,36.26,77,5.94,77,5.94,5.53-2.87,7-11.47-1.23-37.29-2.66-43.64-2.67-4.51-9.43-8.6a154.16,154.16,0,0,0-17.2-8.4l-3.69-7s-11.68-6.35-20.9-1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M278.94,304.62c.14,0,.18,5.56.09,12.43s-.28,12.42-.42,12.42-.19-5.57-.1-12.43S278.79,304.62,278.94,304.62Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M214.55,300.45a3.64,3.64,0,0,1,0,1q0,1.17-.12,2.82c-.1,2.38-.2,5.67-.18,9.31s.18,6.92.32,9.3c.06,1.1.12,2,.16,2.82a4.37,4.37,0,0,1,0,1,3.66,3.66,0,0,1-.21-1c-.1-.66-.21-1.62-.33-2.81-.23-2.38-.44-5.68-.47-9.33s.14-6.95.34-9.33c.09-1.19.19-2.15.28-2.82A3.89,3.89,0,0,1,214.55,300.45Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M271.61,290a1.93,1.93,0,0,1-.53,0l-1.5-.17-5.5-.64c-4.65-.5-11.09-1.06-18.22-1.31s-13.6-.13-18.27.05l-5.54.25-1.5.07a2.67,2.67,0,0,1-.53,0,2.08,2.08,0,0,1,.52-.1L222,288c1.3-.13,3.19-.28,5.53-.42,4.68-.28,11.16-.44,18.31-.2s13.6.87,18.24,1.47c2.33.3,4.2.57,5.49.8l1.49.26A2,2,0,0,1,271.61,290Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M261.29,279c0,.08-1.56-.21-4.06-.58a89,89,0,0,0-19.66-.75c-2.52.18-4.07.36-4.09.28a5,5,0,0,1,1.08-.24c.7-.13,1.72-.27,3-.4a69.74,69.74,0,0,1,9.9-.33,70.74,70.74,0,0,1,9.85,1.07c1.25.24,2.26.45,2.94.63A5.35,5.35,0,0,1,261.29,279Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M283.52,325.42a15,15,0,0,0-6.56-1.5c-13.11-.9-26.26-1.19-39.4-1.47-7.55-.17-15.13-.33-22.63.56-2.36.28-4.85.73-6.6,2.33-2.36,2.15-2.68,5.75-2.31,8.92s1.28,6.36.77,9.51l78.84,7.46c-.11-4.6,1.65-9,2.24-13.57S287.48,327.74,283.52,325.42Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M220.8,388.4a13.34,13.34,0,0,1-13.36-12.91c-.37-13.53-.38-34.48-.36-43.56a4.46,4.46,0,0,1,4.46-4.46h69.51a4.46,4.46,0,0,1,4.46,4.57c-.23,9.43-.76,31.3-1.09,44.86a11.78,11.78,0,0,1-11.79,11.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,462.49l-4-.48,8.18-66.95a7.78,7.78,0,0,1,7.66-6.89h58.61a7.76,7.76,0,0,1,7.64,6.86c2,15.83,7.42,66.5,7.48,67l-4,.42c-.05-.51-5.51-51.14-7.47-66.93a3.75,3.75,0,0,0-3.67-3.36H216.87a3.76,3.76,0,0,0-3.68,3.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,462.49s0-.36.11-1.06.2-1.72.36-3.06c.32-2.69.79-6.65,1.39-11.74,1.22-10.19,3-24.94,5.18-43.21q.42-3.42.85-7a8,8,0,0,1,.33-1.82,4.19,4.19,0,0,1,1.06-1.6,3.94,3.94,0,0,1,1.71-.91,8.27,8.27,0,0,1,1.91-.11h15.71l34.72,0h6.95a3.93,3.93,0,0,1,2.36.67,4,4,0,0,1,1.52,1.94,10.76,10.76,0,0,1,.4,2.39c.17,1.58.35,3.17.53,4.76q1.07,9.57,2.19,19.54c1.48,13.29,3,27.07,4.6,41.21l-.29-.24,4-.42-.23.28c-.2-1.82-.42-3.8-.65-5.77-1.44-13-2.86-25.74-4.24-38.1q-1-9.27-2-18.25c-.17-1.49-.33-3-.5-4.46a7.72,7.72,0,0,0-1.48-4,7.55,7.55,0,0,0-3.34-2.57,7.69,7.69,0,0,0-2.06-.46c-.69-.05-1.44,0-2.15,0l-33.24,0H218c-.61,0-1.21,0-1.78,0a7.5,7.5,0,0,0-1.69.37,7.27,7.27,0,0,0-2.87,1.79,7.45,7.45,0,0,0-1.79,2.82,14.3,14.3,0,0,0-.61,3.28c-.27,2.22-.54,4.39-.8,6.53q-.79,6.39-1.52,12.23c-1,7.78-1.83,14.79-2.59,20.94-1.54,12.26-2.65,21.07-3.22,25.64l0-.05,3,.39,1,.14-.95-.09-3-.34H201V462c.55-4.58,1.6-13.39,3.06-25.67.74-6.14,1.58-13.16,2.52-20.94.47-3.89,1-8,1.48-12.24q.39-3.19.79-6.53a14.8,14.8,0,0,1,.62-3.36,8,8,0,0,1,4.9-4.87,8.19,8.19,0,0,1,1.78-.39c.62,0,1.22,0,1.82,0h7.33l15.37,0,33.24,0c.73,0,1.43,0,2.19,0a8.34,8.34,0,0,1,2.2.49,8,8,0,0,1,3.56,2.74,8.32,8.32,0,0,1,1.58,4.23c.16,1.49.33,3,.5,4.47q1,9,2,18.25c1.38,12.36,2.8,25.09,4.25,38.1.22,2,.44,3.95.65,5.78l0,.26-.26,0-4,.43-.26,0,0-.26c-1.57-14.14-3.11-27.91-4.59-41.2q-1.09-10-2.17-19.54c-.18-1.59-.35-3.18-.53-4.76a10.25,10.25,0,0,0-.37-2.28,3.48,3.48,0,0,0-1.34-1.71,3.38,3.38,0,0,0-2.08-.59h-6.95l-34.72,0H217.9a7.75,7.75,0,0,0-1.82.09,3.49,3.49,0,0,0-1.54.82,3.69,3.69,0,0,0-1,1.44,8,8,0,0,0-.32,1.74q-.44,3.6-.87,7c-2.27,18.29-4.11,33.05-5.38,43.26-.64,5.07-1.14,9-1.48,11.69l-.39,3C205.06,462.15,205,462.49,205,462.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.45,376.28a1.16,1.16,0,0,1,0,.3,2.9,2.9,0,0,1-.05.89,4.34,4.34,0,0,1-1.95,2.72c-2.46,1.74-6.7,2.82-11.91,3.49-10.46,1.3-25.06,1.13-41-.37a14.74,14.74,0,0,1-5.79-1.57,7.83,7.83,0,0,1-3.5-4.65,27,27,0,0,1-.92-5.53c-.17-1.81-.33-3.58-.5-5.32-.59-6.92-.94-13.18-1.13-18.43s-.24-9.51-.24-12.45c0-1.47,0-2.61,0-3.38,0-.37,0-.66,0-.88a1.16,1.16,0,0,1,0-.3,1.16,1.16,0,0,1,0,.3l0,.88c0,.81,0,1.94.06,3.38.07,2.94.17,7.19.41,12.43s.62,11.49,1.24,18.41q.25,2.6.51,5.31a27.29,27.29,0,0,0,.92,5.43,7.3,7.3,0,0,0,3.27,4.35,14.1,14.1,0,0,0,5.59,1.5c15.93,1.5,30.51,1.72,40.94.53,5.18-.62,9.4-1.64,11.83-3.3a4.26,4.26,0,0,0,2-2.58,2.65,2.65,0,0,0,.09-.86A1.25,1.25,0,0,1,277.45,376.28Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-142"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.7,309.49c0,.61,5.63,22.35,5.63,29.4s-6.64,12.88-6.64,12.88l-7.25-15.7-3-19.53Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.77,307.4C89.71,308,91,335.06,91,335.06l10.87-1L99.4,315.93Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.64,284.73c-.12.06-.46.16-1,.33-3,1-13,4.44-14.26,13.21l-1.37,12.47,11.35,5.19,1.41,13.9,49.13,1-1.21-11.67,16.68-3.67s-3.14-15.06-9.24-23.12a13.37,13.37,0,0,0-8-5l-25.38-5.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5,235.26a12.31,12.31,0,0,0-9.81,3.26,24.61,24.61,0,0,0-5.8,8.63c-2.75,6.18-4.35,12.78-5.93,19.34-2.34,9.66-4.68,19.38-5.3,29.28s2.44,15.75,6.87,24.71l15.64-2.09,0-2.87,2.12,2.87,6.07-.91s1.82-15.34,1.82-15.29,2.9,14.6,2.9,14.6l5.06-.45c5-19.27-.66-31.95,2.2-51.63.68-4.68,1.76-9.33,1.74-14.06s-1.28-9.67-4.66-13.09-9.2-4.82-13.34-2.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.33,317.48l-.05-.22-.14-.65c-.11-.6-.26-1.44-.46-2.52-.39-2.19-.92-5.36-1.4-9.3a99,99,0,0,1-.79-13.93,75.06,75.06,0,0,1,.64-8.22A67.18,67.18,0,0,1,132,274c1.73-5.84,4.15-11.15,5.32-16.26a31.82,31.82,0,0,0,.93-7.35,19.93,19.93,0,0,0-1-6.34,17.05,17.05,0,0,0-2.5-4.72,14.74,14.74,0,0,0-2.89-2.88,13.73,13.73,0,0,0-2.23-1.34l-.62-.28-.21-.1.22.07.64.24a12.92,12.92,0,0,1,2.29,1.31,14.72,14.72,0,0,1,3,2.86,17.11,17.11,0,0,1,2.58,4.76,19.86,19.86,0,0,1,1,6.42,31.18,31.18,0,0,1-.9,7.42c-1.17,5.15-3.58,10.48-5.29,16.28a68.4,68.4,0,0,0-1.85,8.63,76.58,76.58,0,0,0-.65,8.18,101.09,101.09,0,0,0,.71,13.89c.45,3.94.94,7.11,1.29,9.31.17,1.08.3,1.93.39,2.52,0,.28.08.5.1.66A.8.8,0,0,1,132.33,317.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.33,307.44s0-.06,0-.18,0-.32-.06-.54c-.06-.5-.13-1.19-.23-2.08,0-.45-.1-.95-.15-1.5s-.08-1.15-.12-1.8c-.07-1.29-.19-2.75-.19-4.38,0-.81,0-1.66-.05-2.55s0-1.81.05-2.76c0-1.91.16-3.95.29-6.09a114.54,114.54,0,0,1,5.46-27.4c.7-2,1.35-4,2.07-5.77.36-.89.67-1.76,1-2.58l1-2.35c.62-1.51,1.3-2.82,1.86-4,.29-.58.54-1.13.8-1.62l.72-1.34,1-1.85.27-.48a1.21,1.21,0,0,1,.1-.16s0,.06-.07.18l-.24.49c-.23.45-.54,1.08-1,1.88-.2.41-.44.86-.69,1.35s-.49,1.05-.77,1.64c-.54,1.17-1.2,2.49-1.81,4l-1,2.35c-.35.82-.65,1.69-1,2.58-.71,1.78-1.34,3.73-2,5.76a119.11,119.11,0,0,0-5.45,27.33c-.14,2.14-.3,4.17-.32,6.08,0,.95-.07,1.87-.06,2.75s0,1.74,0,2.55c0,1.62.09,3.09.14,4.37q0,1,.09,1.8c0,.54.08,1.05.12,1.5.07.89.12,1.58.16,2.09q0,.33,0,.54T110.33,307.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,319.08a.82.82,0,0,1-.08-.18c0-.14-.1-.32-.18-.55-.15-.5-.37-1.2-.65-2.09-.15-.46-.3-1-.47-1.52s-.31-1.18-.48-1.83c-.31-1.32-.75-2.81-1-4.49-.17-.84-.33-1.71-.51-2.63s-.28-1.87-.43-2.86-.32-2-.4-3.09-.19-2.15-.28-3.28a101.38,101.38,0,0,1,.11-14.64,109.59,109.59,0,0,1,2.27-14.49l.77-3.2c.25-1,.56-2,.83-3,.52-1.94,1.12-3.71,1.65-5.34s1.1-3.06,1.56-4.34.9-2.36,1.28-3.24.65-1.54.85-2l.23-.52.09-.18s0,.07,0,.19l-.2.54c-.19.49-.46,1.18-.79,2.05s-.79,2-1.23,3.26-1,2.72-1.5,4.35-1.1,3.4-1.61,5.34c-.26,1-.57,1.95-.81,3s-.49,2.11-.75,3.2A116.42,116.42,0,0,0,115,282a107,107,0,0,0-.14,14.59c.1,1.12.19,2.21.28,3.27s.25,2.09.37,3.08.23,1.95.41,2.86.33,1.79.48,2.63c.27,1.68.7,3.16,1,4.48.16.66.28,1.28.44,1.83l.44,1.53.59,2.11.15.56C119,319,119,319.08,119,319.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,309.77l-.11-.19-.28-.57-.45-.93-.56-1.3a46,46,0,0,1-2.62-8.57,47,47,0,0,1-.8-13.22,47.9,47.9,0,0,1,1.27-7.75c.66-2.65,1.51-5.34,2.39-8.09s1.71-5.44,2.32-8.08a39.49,39.49,0,0,0,1.08-7.71,24.14,24.14,0,0,0-.74-7,18,18,0,0,0-2.56-5.58,16,16,0,0,0-6.85-5.73,14.82,14.82,0,0,0-2.38-.74l-.64-.13-.22,0a.8.8,0,0,1,.23,0l.64.09a13.57,13.57,0,0,1,2.43.69,15.85,15.85,0,0,1,7,5.72,17.92,17.92,0,0,1,2.63,5.64,24.32,24.32,0,0,1,.79,7.06,39.08,39.08,0,0,1-1.07,7.77c-.61,2.66-1.45,5.36-2.32,8.11s-1.73,5.44-2.39,8.07a47.41,47.41,0,0,0-.56,20.84,47.92,47.92,0,0,0,2.5,8.57c.2.49.37.93.53,1.31l.41.94.26.59A.82.82,0,0,1,141,309.77Z",
    style: {
      fill: "#455a64"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.08,300.66a18.09,18.09,0,0,1,.55,2.95c.31,2,.68,4.44,1.1,7.15s.82,5.16,1.13,7.15a18.55,18.55,0,0,1,.38,3A16,16,0,0,1,99.5,318c-.38-1.81-.85-4.33-1.29-7.13s-.75-5.34-.94-7.18A16.61,16.61,0,0,1,97.08,300.66Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M149.71,304.48a83,83,0,0,1-.35,9.28,79.27,79.27,0,0,1-.87,9.25,86.06,86.06,0,0,1,.35-9.28A84.86,84.86,0,0,1,149.71,304.48Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.16,420l-5.62-17.93,12.94-3.92c-.09,0,4.27,22.49,4.27,22.49l-6.29,2.54Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.35,422.3l-4.69-1.58-8.54-3.3-11.55,1.2,1.74,10.4,9.63-.78,16.38-1-.32-1.41A5.38,5.38,0,0,0,167.35,422.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,427.36a23.77,23.77,0,0,1-1.09-4.94,22.64,22.64,0,0,1-.56-5,50.91,50.91,0,0,1,1.65,9.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.31 429.02 144.01 427.25 169.9 425.4 170.32 427.22 144.31 429.02",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.27 447.9 109.27 430.62 123.56 429.72 122.67 448.33 115.87 450.98 109.27 447.9",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,448.21l-5.69-.31s-8.76,7.09-9.6,11a8.45,8.45,0,0,0,0,3l13.29.39h9.71V448.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.9,388.09c.28.68,4.06,20.17,4.06,20.17l23.12-5.2-3-13.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,390.07V430.4l22.7,1,1-41.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.54,
    y: 459.84,
    width: 23.12,
    height: 2.41,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.39,449c.14,0-.47,2.42-1,5.39s-.66,5.42-.82,5.41a18.29,18.29,0,0,1,.31-5.49A17.8,17.8,0,0,1,110.39,449Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.68,459.08a11.47,11.47,0,0,0-1.2-2.19,6.39,6.39,0,0,0-2-1.71,6.23,6.23,0,0,0-6.19.29,6.46,6.46,0,0,0-1.85,1.89,12.89,12.89,0,0,0-1,2.3,1.6,1.6,0,0,1,0-.7,5.94,5.94,0,0,1,.65-1.78,6.29,6.29,0,0,1,10.68-.51,5.86,5.86,0,0,1,.82,1.72A1.36,1.36,0,0,1,121.68,459.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,388.4a13.33,13.33,0,0,1-13.36-12.91c-.37-13.53-.38-34.48-.36-43.56a4.46,4.46,0,0,1,4.46-4.46h69.51a4.46,4.46,0,0,1,4.46,4.57c-.23,9.43-.76,31.3-1.09,44.86a11.79,11.79,0,0,1-11.79,11.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.17,462.49l-4-.48,8.18-66.95A7.77,7.77,0,0,1,97,388.17h58.61a7.76,7.76,0,0,1,7.65,6.86c2,15.83,7.42,66.5,7.48,67l-4,.42c-.06-.51-5.51-51.14-7.47-66.93a3.76,3.76,0,0,0-3.68-3.36H97a3.78,3.78,0,0,0-3.68,3.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.17,462.49s0-.36.11-1.06.2-1.72.36-3.06c.32-2.69.78-6.65,1.39-11.74,1.22-10.19,3-24.94,5.18-43.21q.42-3.42.85-7a8,8,0,0,1,.33-1.82,4.08,4.08,0,0,1,1.06-1.6,3.89,3.89,0,0,1,1.71-.91,8.27,8.27,0,0,1,1.91-.11h15.71l34.72,0h6.95a3.88,3.88,0,0,1,2.35.67,4.07,4.07,0,0,1,1.53,1.94,10.73,10.73,0,0,1,.39,2.39l.54,4.76q1.06,9.57,2.18,19.54c1.49,13.29,3,27.07,4.61,41.21l-.29-.24,4-.42-.23.28c-.21-1.82-.43-3.8-.65-5.77-1.45-13-2.86-25.74-4.24-38.1q-1-9.27-2-18.25c-.17-1.49-.33-3-.5-4.46a7.72,7.72,0,0,0-1.48-4,7.55,7.55,0,0,0-3.34-2.57,7.69,7.69,0,0,0-2.06-.46c-.69-.05-1.44,0-2.16,0l-33.24,0H98.11c-.6,0-1.2,0-1.77,0a7.52,7.52,0,0,0-6.35,5,14.3,14.3,0,0,0-.61,3.28c-.27,2.22-.54,4.39-.81,6.53q-.78,6.39-1.51,12.23c-1,7.78-1.83,14.79-2.59,20.94-1.54,12.26-2.65,21.07-3.22,25.64l0-.05,3,.39,1,.14-1-.09-3-.34h0V462c.55-4.58,1.59-13.39,3-25.67.74-6.14,1.59-13.16,2.53-20.94.47-3.89,1-8,1.48-12.24q.39-3.19.79-6.53a14.27,14.27,0,0,1,.62-3.36,8,8,0,0,1,4.9-4.87A8.19,8.19,0,0,1,96.3,388c.62,0,1.21,0,1.81,0h7.34l15.36,0,33.24,0c.73,0,1.44,0,2.2,0a8.34,8.34,0,0,1,2.2.49,8.06,8.06,0,0,1,3.56,2.74,8.32,8.32,0,0,1,1.58,4.23c.16,1.49.33,3,.5,4.47q1,9,2,18.25c1.38,12.36,2.8,25.09,4.25,38.1.22,2,.44,3.95.65,5.78l0,.26-.26,0-4,.43-.26,0,0-.26c-1.57-14.14-3.11-27.91-4.59-41.2q-1.11-10-2.17-19.54c-.18-1.59-.35-3.18-.53-4.76a10.25,10.25,0,0,0-.37-2.28,3.59,3.59,0,0,0-1.34-1.71,3.4,3.4,0,0,0-2.08-.59H148.5l-34.72,0H98.07a7.75,7.75,0,0,0-1.82.09,3.44,3.44,0,0,0-1.54.82,3.58,3.58,0,0,0-1,1.44,7.45,7.45,0,0,0-.32,1.74c-.3,2.4-.58,4.75-.87,7-2.28,18.29-4.11,33.05-5.38,43.26-.64,5.07-1.14,9-1.48,11.69l-.39,3C85.22,462.15,85.17,462.49,85.17,462.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.62,376.28a1,1,0,0,1,0,.3,2.56,2.56,0,0,1,0,.89,4.33,4.33,0,0,1-2,2.72c-2.45,1.74-6.69,2.82-11.9,3.49-10.46,1.3-25.06,1.13-41-.37a14.74,14.74,0,0,1-5.79-1.57,7.79,7.79,0,0,1-3.5-4.65,27,27,0,0,1-.92-5.53c-.17-1.81-.34-3.58-.5-5.32-.59-6.92-.94-13.18-1.13-18.43s-.24-9.51-.24-12.45c0-1.47,0-2.61,0-3.38,0-.37,0-.66,0-.88a1.16,1.16,0,0,1,0-.3,1.16,1.16,0,0,1,0,.3c0,.22,0,.51,0,.88,0,.81,0,1.94.07,3.38.07,2.94.16,7.19.41,12.43s.62,11.49,1.24,18.41q.25,2.6.51,5.31a27.29,27.29,0,0,0,.92,5.43,7.3,7.3,0,0,0,3.27,4.35,14.05,14.05,0,0,0,5.58,1.5c15.94,1.5,30.52,1.72,40.95.53,5.18-.62,9.4-1.64,11.83-3.3a4.23,4.23,0,0,0,2-2.58,2.71,2.71,0,0,0,.1-.86A1.25,1.25,0,0,1,157.62,376.28Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationMotion);
export default __webpack_public_path__ + "static/media/nation-motion.79a3a15cdd1f40784fe41dd0fceaea4e.svg";
export { ForwardRef as ReactComponent };